/** Shopify CDN: Minification failed

Line 3928:0 Transforming const to the configured target environment ("es5") is not supported yet

**/
var bssB2BArrayState = {
    "AF": { "labels": { "zip": "Postal code (optional)" } },
    "AX": {},
    "AL": { "labels": { "zip": "Postal code (optional)" } },
    "DZ": {},
    "AD": {},
    "AO": {},
    "AI": {},
    "AG": {},
    "AR": {
        "provinces": [
            {
                "id": "Ciudad Autónoma de Buenos Aires",
                "label": "Buenos Aires (Autonomous City)",
                "alternate_names": ["Ciudad Autonoma de Buenos Aires"],
                "value": "C"
            },
            {
                "id": "Buenos Aires",
                "label": "Buenos Aires Province",
                "value": "B"
            },
            { "id": "Catamarca", "label": "Catamarca", "value": "K" },
            { "id": "Chaco", "label": "Chaco", "value": "H" },
            { "id": "Chubut", "label": "Chubut", "value": "U" },
            {
                "id": "Córdoba",
                "alternate_names": ["Cordoba"],
                "label": "Córdoba",
                "value": "X"
            },
            { "id": "Corrientes", "label": "Corrientes", "value": "W" },
            {
                "id": "Entre Ríos",
                "alternate_names": ["Entre Rios"],
                "label": "Entre Ríos",
                "value": "E"
            },
            { "id": "Formosa", "label": "Formosa", "value": "P" },
            { "id": "Jujuy", "label": "Jujuy", "value": "Y" },
            { "id": "La Pampa", "label": "La Pampa", "value": "L" },
            { "id": "La Rioja", "label": "La Rioja", "value": "F" },
            { "id": "Mendoza", "label": "Mendoza", "value": "M" },
            { "id": "Misiones", "label": "Misiones", "value": "N" },
            {
                "id": "Neuquén",
                "alternate_names": ["Neuquen"],
                "label": "Neuquén",
                "value": "Q"
            },
            {
                "id": "Río Negro",
                "alternate_names": ["Rio Negro"],
                "label": "Río Negro",
                "value": "R"
            },
            { "id": "Salta", "label": "Salta", "value": "A" },
            { "id": "San Juan", "label": "San Juan", "value": "J" },
            { "id": "San Luis", "label": "San Luis", "value": "D" },
            { "id": "Santa Cruz", "label": "Santa Cruz", "value": "Z" },
            { "id": "Santa Fe", "label": "Santa Fe", "value": "S" },
            {
                "id": "Santiago Del Estero",
                "label": "Santiago del Estero",
                "value": "G"
            },
            {
                "id": "Tierra Del Fuego",
                "label": "Tierra del Fuego",
                "value": "V"
            },
            {
                "id": "Tucumán",
                "alternate_names": ["Tucuman"],
                "label": "Tucumán",
                "value": "T"
            }
        ],
        "labels": { "province": "Province" }
    },
    "AM": {},
    "AW": {},
    "AC": {},
    "AU": {
        "provinces": [
            {
                "id": "Australian Capital Territory",
                "label": "Australian Capital Territory",
                "value": "ACT"
            },
            {
                "id": "New South Wales",
                "label": "New South Wales",
                "value": "NSW"
            },
            {
                "id": "Northern Territory",
                "label": "Northern Territory",
                "value": "NT"
            },
            { "id": "Queensland", "label": "Queensland", "value": "QLD" },
            {
                "id": "South Australia",
                "label": "South Australia",
                "value": "SA"
            },
            { "id": "Tasmania", "label": "Tasmania", "value": "TAS" },
            { "id": "Victoria", "label": "Victoria", "value": "VIC" },
            {
                "id": "Western Australia",
                "label": "Western Australia",
                "value": "WA"
            }
        ],
        "labels": {
            "city": "Suburb",
            "province": "State/territory",
            "zip": "Postcode"
        }
    },
    "AT": {
        "labels": {
            "address1": "Street and house number",
            "address2": "Additional address (optional)"
        }
    },
    "AZ": {},
    "BS": {},
    "BH": { "labels": { "zip": "Postal code (optional)" } },
    "BD": {},
    "BB": { "labels": { "zip": "Postal code (optional)" } },
    "BY": {},
    "BE": {},
    "BZ": {},
    "BJ": {},
    "BM": {},
    "BT": { "labels": { "zip": "Postal code (optional)" } },
    "BO": {},
    "BA": {},
    "BW": {},
    "BV": { "labels": { "zip": "Postal code (optional)" } },
    "BR": {
        "provinces": [
            { "id": "Acre", "label": "Acre", "value": "AC" },
            { "id": "Alagoas", "label": "Alagoas", "value": "AL" },
            {
                "id": "Amapá",
                "alternate_names": ["Amapa"],
                "label": "Amapá",
                "value": "AP"
            },
            { "id": "Amazonas", "label": "Amazonas", "value": "AM" },
            { "id": "Bahia", "label": "Bahia", "value": "BA" },
            {
                "id": "Ceará",
                "alternate_names": ["Ceara"],
                "label": "Ceará",
                "value": "CE"
            },
            {
                "id": "Espírito Santo",
                "alternate_names": ["Espirito Santo"],
                "label": "Espírito Santo",
                "value": "ES"
            },
            {
                "id": "Distrito Federal",
                "label": "Federal District",
                "value": "DF"
            },
            {
                "id": "Goiás",
                "alternate_names": ["Goias"],
                "label": "Goiás",
                "value": "GO"
            },
            {
                "id": "Maranhão",
                "alternate_names": ["Maranhao"],
                "label": "Maranhão",
                "value": "MA"
            },
            { "id": "Mato Grosso", "label": "Mato Grosso", "value": "MT" },
            {
                "id": "Mato Grosso do Sul",
                "label": "Mato Grosso do Sul",
                "value": "MS"
            },
            { "id": "Minas Gerais", "label": "Minas Gerais", "value": "MG" },
            {
                "id": "Pará",
                "alternate_names": ["Para"],
                "label": "Pará",
                "value": "PA"
            },
            {
                "id": "Paraíba",
                "alternate_names": ["Paraiba"],
                "label": "Paraíba",
                "value": "PB"
            },
            {
                "id": "Paraná",
                "alternate_names": ["Parana"],
                "label": "Paraná",
                "value": "PR"
            },
            { "id": "Pernambuco", "label": "Pernambuco", "value": "PE" },
            {
                "id": "Piauí",
                "alternate_names": ["Piaui"],
                "label": "Piauí",
                "value": "PI"
            },
            {
                "id": "Rio Grande do Norte",
                "label": "Rio Grande do Norte",
                "value": "RN"
            },
            {
                "id": "Rio Grande do Sul",
                "label": "Rio Grande do Sul",
                "value": "RS"
            },
            {
                "id": "Rio de Janeiro",
                "label": "Rio de Janeiro",
                "value": "RJ"
            },
            {
                "id": "Rondônia",
                "alternate_names": ["Rondonia"],
                "label": "Rondônia",
                "value": "RO"
            },
            { "id": "Roraima", "label": "Roraima", "value": "RR" },
            {
                "id": "Santa Catarina",
                "label": "Santa Catarina",
                "value": "SC"
            },
            {
                "id": "São Paulo",
                "alternate_names": ["Sao Paulo"],
                "label": "São Paulo",
                "value": "SP"
            },
            { "id": "Sergipe", "label": "Sergipe", "value": "SE" },
            { "id": "Tocantins", "label": "Tocantins", "value": "TO" }
        ],
        "labels": { "address1": "Street and house number", "province": "State" }
    },
    "IO": { "labels": { "zip": "Postal code (optional)" } },
    "BN": {},
    "BG": {},
    "BF": { "labels": { "zip": "Postal code (optional)" } },
    "BI": {},
    "KH": { "labels": { "zip": "Postal code (optional)" } },
    "CA": {
        "provinces": [
            { "id": "Alberta", "label": "Alberta", "value": "AB" },
            {
                "id": "British Columbia",
                "label": "British Columbia",
                "value": "BC"
            },
            { "id": "Manitoba", "label": "Manitoba", "value": "MB" },
            { "id": "New Brunswick", "label": "New Brunswick", "value": "NB" },
            {
                "id": "Newfoundland and Labrador",
                "alternate_names": ["Newfoundland"],
                "label": "Newfoundland and Labrador",
                "value": "NL"
            },
            {
                "id": "Northwest Territories",
                "label": "Northwest Territories",
                "value": "NT"
            },
            { "id": "Nova Scotia", "label": "Nova Scotia", "value": "NS" },
            { "id": "Nunavut", "label": "Nunavut", "value": "NU" },
            { "id": "Ontario", "label": "Ontario", "value": "ON" },
            {
                "id": "Prince Edward Island",
                "label": "Prince Edward Island",
                "value": "PE"
            },
            {
                "id": "Quebec",
                "alternate_names": ["Québec"],
                "label": "Quebec",
                "value": "QC"
            },
            { "id": "Saskatchewan", "label": "Saskatchewan", "value": "SK" },
            { "id": "Yukon", "label": "Yukon", "value": "YT" }
        ],
        "labels": { "province": "Province" }
    },
    "CV": { "labels": { "zip": "Postal code (optional)" } },
    "BQ": {},
    "KY": { "labels": { "zip": "Postal code (optional)" } },
    "CF": {},
    "TD": {},
    "CL": {
        "provinces": [
            {
                "id": "Arica and Parinacota",
                "label": "Arica y Parinacota",
                "alternate_names": [
                    "Arica y Parinacota",
                    "Región de Arica y Parinacota",
                    "Region de Arica y Parinacota"
                ],
                "value": "AP"
            },
            {
                "id": "Tarapacá",
                "alternate_names": [
                    "Tarapaca",
                    "Región de Tarapacá",
                    "Region de Tarapaca"
                ],
                "label": "Tarapacá",
                "value": "TA"
            },
            {
                "id": "Antofagasta",
                "alternate_names": [
                    "Región de Antofagasta",
                    "Region de Antofagasta"
                ],
                "label": "Antofagasta",
                "value": "AN"
            },
            {
                "id": "Atacama",
                "alternate_names": ["Región de Atacama", "Region de Atacama"],
                "label": "Atacama",
                "value": "AT"
            },
            {
                "id": "Coquimbo",
                "alternate_names": ["Región de Coquimbo", "Region de Coquimbo"],
                "label": "Coquimbo",
                "value": "CO"
            },
            {
                "id": "Valparaíso",
                "alternate_names": [
                    "Valparaiso",
                    "Región de Valparaíso",
                    "Region de Valparaiso"
                ],
                "label": "Valparaíso",
                "value": "VS"
            },
            {
                "id": "Santiago",
                "label": "Santiago Metropolitan",
                "alternate_names": [
                    "Región Metropolitana",
                    "Region Metropolitana",
                    "Región Metropolitana de Santiago",
                    "Region Metropolitana de Santiago"
                ],
                "value": "RM"
            },
            {
                "id": "O'Higgins",
                "label": "Libertador General Bernardo O’Higgins",
                "alternate_names": [
                    "Región del Libertador General Bernardo O'Higgins",
                    "Region del Libertador General Bernardo O'Higgins"
                ],
                "value": "LI"
            },
            {
                "id": "Maule",
                "alternate_names": ["Región del Maule", "Region del Maule"],
                "label": "Maule",
                "value": "ML"
            },
            {
                "id": "Ñuble",
                "alternate_names": [
                    "Nuble",
                    "Región de Ñuble",
                    "Region de Nuble"
                ],
                "label": "Ñuble",
                "value": "NB"
            },
            {
                "id": "Biobío",
                "label": "Bío Bío",
                "alternate_names": [
                    "Biobio",
                    "Región del Biobío",
                    "Region del Biobio"
                ],
                "value": "BI"
            },
            {
                "id": "Araucanía",
                "alternate_names": [
                    "Araucania",
                    "Región de La Araucanía",
                    "Region de La Araucania"
                ],
                "label": "Araucanía",
                "value": "AR"
            },
            {
                "id": "Los Ríos",
                "alternate_names": [
                    "Los Rios",
                    "Región de Los Ríos",
                    "Region de Los Rios"
                ],
                "label": "Los Ríos",
                "value": "LR"
            },
            {
                "id": "Los Lagos",
                "alternate_names": [
                    "Región de Los Lagos",
                    "Region de Los Lagos"
                ],
                "label": "Los Lagos",
                "value": "LL"
            },
            {
                "id": "Aysén",
                "alternate_names": [
                    "Aysen",
                    "Región Aysén del General Carlos Ibáñez del Campo",
                    "Region Aysen del General Carlos Ibanez del Campo"
                ],
                "label": "Aysén",
                "value": "AI"
            },
            {
                "id": "Magallanes",
                "label": "Magallanes Region",
                "alternate_names": [
                    "Magallanes y la Antártica Chilena",
                    "Magallanes y la Antartica Chilena",
                    "Magallanes and Chilean Antarctica",
                    "Región de Magallanes y de la Antártica Chilena",
                    "Region de Magallanes y de la Antartica Chilena"
                ],
                "value": "MA"
            }
        ],
        "labels": { "zip": "Postal code (optional)", "province": "Region" }
    },
    "CN": {
        "provinces": [
            {
                "id": "Anhui",
                "alternate_names": ["安徽"],
                "label": "Anhui",
                "value": "AH"
            },
            {
                "id": "Beijing",
                "alternate_names": ["北京"],
                "label": "Beijing",
                "value": "BJ"
            },
            {
                "id": "Chongqing",
                "alternate_names": ["重庆"],
                "label": "Chongqing",
                "value": "CQ"
            },
            {
                "id": "Fujian",
                "alternate_names": ["福建"],
                "label": "Fujian",
                "value": "FJ"
            },
            {
                "id": "Gansu",
                "alternate_names": ["甘肃"],
                "label": "Gansu",
                "value": "GS"
            },
            {
                "id": "Guangdong",
                "alternate_names": ["广东"],
                "label": "Guangdong",
                "value": "GD"
            },
            {
                "id": "Guangxi",
                "alternate_names": ["广西"],
                "label": "Guangxi",
                "value": "GX"
            },
            {
                "id": "Guizhou",
                "alternate_names": ["贵州"],
                "label": "Guizhou",
                "value": "GZ"
            },
            {
                "id": "Hainan",
                "alternate_names": ["海南"],
                "label": "Hainan",
                "value": "HI"
            },
            {
                "id": "Hebei",
                "alternate_names": ["河北"],
                "label": "Hebei",
                "value": "HE"
            },
            {
                "id": "Heilongjiang",
                "alternate_names": ["黑龙江"],
                "label": "Heilongjiang",
                "value": "HL"
            },
            {
                "id": "Henan",
                "alternate_names": ["河南"],
                "label": "Henan",
                "value": "HA"
            },
            {
                "id": "Hubei",
                "alternate_names": ["湖北"],
                "label": "Hubei",
                "value": "HB"
            },
            {
                "id": "Hunan",
                "alternate_names": ["湖南"],
                "label": "Hunan",
                "value": "HN"
            },
            {
                "id": "Inner Mongolia",
                "alternate_names": ["内蒙古", "Nei Mongol"],
                "label": "Inner Mongolia",
                "value": "NM"
            },
            {
                "id": "Jiangsu",
                "alternate_names": ["江苏"],
                "label": "Jiangsu",
                "value": "JS"
            },
            {
                "id": "Jiangxi",
                "alternate_names": ["江西"],
                "label": "Jiangxi",
                "value": "JX"
            },
            {
                "id": "Jilin",
                "alternate_names": ["吉林"],
                "label": "Jilin",
                "value": "JL"
            },
            {
                "id": "Liaoning",
                "alternate_names": ["辽宁"],
                "label": "Liaoning",
                "value": "LN"
            },
            {
                "id": "Ningxia",
                "alternate_names": ["宁夏"],
                "label": "Ningxia",
                "value": "NX"
            },
            {
                "id": "Qinghai",
                "alternate_names": ["青海"],
                "label": "Qinghai",
                "value": "QH"
            },
            {
                "id": "Shaanxi",
                "alternate_names": ["陕西"],
                "label": "Shaanxi",
                "value": "SN"
            },
            {
                "id": "Shandong",
                "alternate_names": ["山东"],
                "label": "Shandong",
                "value": "SD"
            },
            {
                "id": "Shanghai",
                "alternate_names": ["上海"],
                "label": "Shanghai",
                "value": "SH"
            },
            {
                "id": "Shanxi",
                "alternate_names": ["山西"],
                "label": "Shanxi",
                "value": "SX"
            },
            {
                "id": "Sichuan",
                "alternate_names": ["四川"],
                "label": "Sichuan",
                "value": "SC"
            },
            {
                "id": "Tianjin",
                "alternate_names": ["天津"],
                "label": "Tianjin",
                "value": "TJ"
            },
            {
                "id": "Xizang",
                "label": "Tibet",
                "alternate_names": ["西藏", "Tibet"],
                "value": "YZ"
            },
            {
                "id": "Xinjiang",
                "alternate_names": ["新疆"],
                "label": "Xinjiang",
                "value": "XJ"
            },
            {
                "id": "Yunnan",
                "alternate_names": ["云南"],
                "label": "Yunnan",
                "value": "YN"
            },
            {
                "id": "Zhejiang",
                "alternate_names": ["浙江"],
                "label": "Zhejiang",
                "value": "ZJ"
            }
        ],
        "labels": { "address1": "Full address", "province": "Province" }
    },
    "CX": {},
    "CC": {},
    "CO": {
        "provinces": [
            {
                "id": "Bogotá, D.C.",
                "label": "Capital District",
                "alternate_names": [
                    "Bogota, D.C.",
                    "Bogotá",
                    "Bogota",
                    "Capital District",
                    "Distrito Capital de Bogotá",
                    "Distrito Capital de Bogota"
                ],
                "value": "DC"
            },
            { "id": "Amazonas", "label": "Amazonas", "value": "AMA" },
            { "id": "Antioquia", "label": "Antioquia", "value": "ANT" },
            { "id": "Arauca", "label": "Arauca", "value": "ARA" },
            {
                "id": "Atlántico",
                "alternate_names": ["Atlantico"],
                "label": "Atlántico",
                "value": "ATL"
            },
            {
                "id": "Bolívar",
                "alternate_names": ["Bolivar"],
                "label": "Bolívar",
                "value": "BOL"
            },
            {
                "id": "Boyacá",
                "alternate_names": ["Boyaca"],
                "label": "Boyacá",
                "value": "BOY"
            },
            { "id": "Caldas", "label": "Caldas", "value": "CAL" },
            {
                "id": "Caquetá",
                "alternate_names": ["Caqueta"],
                "label": "Caquetá",
                "value": "CAQ"
            },
            { "id": "Casanare", "label": "Casanare", "value": "CAS" },
            { "id": "Cauca", "label": "Cauca", "value": "CAU" },
            { "id": "Cesar", "label": "Cesar", "value": "CES" },
            {
                "id": "Chocó",
                "alternate_names": ["Choco"],
                "label": "Chocó",
                "value": "CHO"
            },
            {
                "id": "Córdoba",
                "alternate_names": ["Cordoba"],
                "label": "Córdoba",
                "value": "COR"
            },
            { "id": "Cundinamarca", "label": "Cundinamarca", "value": "CUN" },
            {
                "id": "Guainía",
                "alternate_names": ["Guainia"],
                "label": "Guainía",
                "value": "GUA"
            },
            { "id": "Guaviare", "label": "Guaviare", "value": "GUV" },
            { "id": "Huila", "label": "Huila", "value": "HUI" },
            { "id": "La Guajira", "label": "La Guajira", "value": "LAG" },
            { "id": "Magdalena", "label": "Magdalena", "value": "MAG" },
            { "id": "Meta", "label": "Meta", "value": "MET" },
            {
                "id": "Nariño",
                "alternate_names": ["Narino"],
                "label": "Nariño",
                "value": "NAR"
            },
            {
                "id": "Norte de Santander",
                "label": "Norte de Santander",
                "value": "NSA"
            },
            { "id": "Putumayo", "label": "Putumayo", "value": "PUT" },
            {
                "id": "Quindío",
                "alternate_names": ["Quindio"],
                "label": "Quindío",
                "value": "QUI"
            },
            { "id": "Risaralda", "label": "Risaralda", "value": "RIS" },
            {
                "id": "San Andrés, Providencia y Santa Catalina",
                "label": "San Andrés & Providencia",
                "alternate_names": [
                    "San Andres, Providencia y Santa Catalina",
                    "San Andrés y Providencia",
                    "San Andres y Providencia"
                ],
                "value": "SAP"
            },
            { "id": "Santander", "label": "Santander", "value": "SAN" },
            { "id": "Sucre", "label": "Sucre", "value": "SUC" },
            { "id": "Tolima", "label": "Tolima", "value": "TOL" },
            {
                "id": "Valle del Cauca",
                "label": "Valle del Cauca",
                "value": "VAC"
            },
            {
                "id": "Vaupés",
                "alternate_names": ["Vaupes"],
                "label": "Vaupés",
                "value": "VAU"
            },
            { "id": "Vichada", "label": "Vichada", "value": "VID" }
        ],
        "labels": { "province": "Province" }
    },
    "KM": {},
    "CG": {},
    "CD": {},
    "CK": {},
    "CR": { "labels": { "zip": "Postal code (optional)" } },
    "HR": {},
    "CU": { "labels": { "zip": "Postal code (optional)" } },
    "CW": {},
    "CY": {},
    "CZ": {},
    "CI": {},
    "DK": { "labels": { "address1": "Street and house number" } },
    "DJ": {},
    "DM": {},
    "DO": { "labels": { "zip": "Postal code (optional)" } },
    "EC": {},
    "EG": {
        "provinces": [
            {
                "id": "6th of October",
                "alternate_names": [
                    "As Sādis min Uktūbar",
                    "As Sadis min Uktubar"
                ],
                "label": "6th of October",
                "value": "SU"
            },
            {
                "id": "Al Sharqia",
                "alternate_names": ["Ash Sharqīyah", "Ash Sharqiyah"],
                "label": "Al Sharqia",
                "value": "SHR"
            },
            {
                "id": "Alexandria",
                "alternate_names": ["Al Iskandarīyah", "Al Iskandariyah"],
                "label": "Alexandria",
                "value": "ALX"
            },
            {
                "id": "Aswan",
                "alternate_names": ["Aswān"],
                "label": "Aswan",
                "value": "ASN"
            },
            {
                "id": "Asyut",
                "alternate_names": ["Asyūţ"],
                "label": "Asyut",
                "value": "AST"
            },
            {
                "id": "Beheira",
                "alternate_names": ["Al Buḩayrah", "Al Buayrah"],
                "label": "Beheira",
                "value": "BH"
            },
            {
                "id": "Beni Suef",
                "alternate_names": ["Banī Suwayf", "Bani Suwayf"],
                "label": "Beni Suef",
                "value": "BNS"
            },
            {
                "id": "Cairo",
                "alternate_names": ["Al Qāhirah", "Al Qahirah"],
                "label": "Cairo",
                "value": "C"
            },
            {
                "id": "Dakahlia",
                "alternate_names": ["Ad Daqahlīyah", "Ad Daqahliyah"],
                "label": "Dakahlia",
                "value": "DK"
            },
            {
                "id": "Damietta",
                "alternate_names": ["Dumyāţ", "Dumyat"],
                "label": "Damietta",
                "value": "DT"
            },
            {
                "id": "Faiyum",
                "alternate_names": ["Al Fayyūm", "Al Fayyum"],
                "label": "Faiyum",
                "value": "FYM"
            },
            {
                "id": "Gharbia",
                "alternate_names": ["Al Gharbīyah", "Al Gharbiyah"],
                "label": "Gharbia",
                "value": "GH"
            },
            {
                "id": "Giza",
                "alternate_names": ["Al Jīzah", "Al Jizah"],
                "label": "Giza",
                "value": "GZ"
            },
            {
                "id": "Helwan",
                "alternate_names": ["Ḩulwān", "ulwan"],
                "label": "Helwan",
                "value": "HU"
            },
            {
                "id": "Ismailia",
                "alternate_names": ["Al Ismāٰīlīyah", "Al Ismailiyah"],
                "label": "Ismailia",
                "value": "IS"
            },
            {
                "id": "Kafr el-Sheikh",
                "alternate_names": ["Kafr ash Shaykh"],
                "label": "Kafr el-Sheikh",
                "value": "KFS"
            },
            {
                "id": "Luxor",
                "alternate_names": ["Al Uqşur", "Al Uqsur"],
                "label": "Luxor",
                "value": "LX"
            },
            {
                "id": "Matrouh",
                "alternate_names": ["Maţrūḩ", "Matru"],
                "label": "Matrouh",
                "value": "MT"
            },
            {
                "id": "Minya",
                "alternate_names": ["Al Minyā", "Al Minya"],
                "label": "Minya",
                "value": "MN"
            },
            {
                "id": "Monufia",
                "alternate_names": ["Al Minūfīyah", "Al Minufiyah"],
                "label": "Monufia",
                "value": "MNF"
            },
            {
                "id": "New Valley",
                "alternate_names": ["Al Wādī al Jadīd", "Al Wadi al Jadid"],
                "label": "New Valley",
                "value": "WAD"
            },
            {
                "id": "North Sinai",
                "alternate_names": ["Shamāl Sīnā", "Shamal Sina"],
                "label": "North Sinai",
                "value": "SIN"
            },
            {
                "id": "Port Said",
                "alternate_names": ["Būr Saٰīd", "Bur Said"],
                "label": "Port Said",
                "value": "PTS"
            },
            {
                "id": "Qalyubia",
                "alternate_names": ["Al Qalyūbīyah", "Al Qalyubiyah"],
                "label": "Qalyubia",
                "value": "KB"
            },
            {
                "id": "Qena",
                "alternate_names": ["Qinā", "Qina"],
                "label": "Qena",
                "value": "KN"
            },
            {
                "id": "Red Sea",
                "alternate_names": ["Al Baḩr al Aḩmar", "Al Bar al Amar"],
                "label": "Red Sea",
                "value": "BA"
            },
            {
                "id": "Sohag",
                "alternate_names": ["Sūhāj", "Suhaj"],
                "label": "Sohag",
                "value": "SHG"
            },
            {
                "id": "South Sinai",
                "alternate_names": ["Janūb Sīnā", "Janub Sina"],
                "label": "South Sinai",
                "value": "JS"
            },
            {
                "id": "Suez",
                "alternate_names": ["As Suways"],
                "label": "Suez",
                "value": "SUZ"
            }
        ],
        "labels": { "province": "Governorate", "zip": "Postal code (optional)" }
    },
    "SV": { "labels": { "zip": "Postal code (optional)" } },
    "GQ": {},
    "ER": {},
    "EE": {},
    "SZ": { "labels": { "zip": "Postal code (optional)" } },
    "ET": { "labels": { "zip": "Postal code (optional)" } },
    "FK": {},
    "FO": {},
    "FJ": {},
    "FI": {},
    "FR": {},
    "GF": {},
    "PF": {},
    "TF": {},
    "GA": {},
    "GM": {},
    "GE": {},
    "DE": {
        "labels": {
            "address1": "Street and house number",
            "address2": "Additional address (optional)"
        }
    },
    "GH": { "labels": { "zip": "Postal code (optional)" } },
    "GI": {},
    "GR": {},
    "GL": {},
    "GD": {},
    "GP": {},
    "GT": {
        "provinces": [
            { "id": "Alta Verapaz", "label": "Alta Verapaz", "value": "AVE" },
            { "id": "Baja Verapaz", "label": "Baja Verapaz", "value": "BVE" },
            { "id": "Chimaltenango", "label": "Chimaltenango", "value": "CMT" },
            { "id": "Chiquimula", "label": "Chiquimula", "value": "CQM" },
            { "id": "El Progreso", "label": "El Progreso", "value": "EPR" },
            { "id": "Escuintla", "label": "Escuintla", "value": "ESC" },
            { "id": "Guatemala", "label": "Guatemala", "value": "GUA" },
            { "id": "Huehuetenango", "label": "Huehuetenango", "value": "HUE" },
            { "id": "Izabal", "label": "Izabal", "value": "IZA" },
            { "id": "Jalapa", "label": "Jalapa", "value": "JAL" },
            { "id": "Jutiapa", "label": "Jutiapa", "value": "JUT" },
            {
                "id": "Petén",
                "alternate_names": ["Peten"],
                "label": "Petén",
                "value": "PET"
            },
            {
                "id": "Quetzaltenango",
                "label": "Quetzaltenango",
                "value": "QUE"
            },
            {
                "id": "Quiché",
                "alternate_names": ["Quiche"],
                "label": "Quiché",
                "value": "QUI"
            },
            { "id": "Retalhuleu", "label": "Retalhuleu", "value": "RET" },
            {
                "id": "Sacatepéquez",
                "alternate_names": ["Sacatepequez"],
                "label": "Sacatepéquez",
                "value": "SAC"
            },
            { "id": "San Marcos", "label": "San Marcos", "value": "SMA" },
            { "id": "Santa Rosa", "label": "Santa Rosa", "value": "SRO" },
            {
                "id": "Sololá",
                "alternate_names": ["Solola"],
                "label": "Sololá",
                "value": "SOL"
            },
            {
                "id": "Suchitepéquez",
                "alternate_names": ["Suchitepequez"],
                "label": "Suchitepéquez",
                "value": "SUC"
            },
            {
                "id": "Totonicapán",
                "alternate_names": ["Totonicapan"],
                "label": "Totonicapán",
                "value": "TOT"
            },
            { "id": "Zacapa", "label": "Zacapa", "value": "ZAC" }
        ],
        "labels": { "zip": "Postal code (optional)", "province": "Region" }
    },
    "GG": {},
    "GN": { "labels": { "zip": "Postal code (optional)" } },
    "GW": { "labels": { "zip": "Postal code (optional)" } },
    "GY": {},
    "HT": { "labels": { "zip": "Postal code (optional)" } },
    "HM": { "labels": { "zip": "Postal code (optional)" } },
    "VA": {},
    "HN": { "labels": { "zip": "Postal code (optional)" } },
    "HK": {
        "provinces": [
            {
                "id": "Hong Kong Island",
                "alternate_names": [
                    "Hong Kong Province",
                    "Hong Kong",
                    "香港",
                    "香港島"
                ],
                "label": "Hong Kong Island",
                "value": "HK"
            },
            {
                "id": "Kowloon",
                "alternate_names": ["九龍"],
                "label": "Kowloon",
                "value": "KL"
            },
            {
                "id": "New Territories",
                "alternate_names": ["新界"],
                "label": "New Territories",
                "value": "NT"
            }
        ],
        "labels": { "city": "District", "province": "Region" }
    },
    "HU": {},
    "IS": {},
    "IN": {
        "provinces": [
            {
                "id": "Andaman and Nicobar Islands",
                "alternate_names": ["Andaman and Nicobar"],
                "label": "Andaman and Nicobar Islands",
                "value": "AN"
            },
            {
                "id": "Andhra Pradesh",
                "label": "Andhra Pradesh",
                "value": "AP"
            },
            {
                "id": "Arunachal Pradesh",
                "label": "Arunachal Pradesh",
                "value": "AR"
            },
            { "id": "Assam", "label": "Assam", "value": "AS" },
            { "id": "Bihar", "label": "Bihar", "value": "BR" },
            { "id": "Chandigarh", "label": "Chandigarh", "value": "CH" },
            {
                "id": "Chhattisgarh",
                "alternate_names": ["Chattisgarh", "CT"],
                "label": "Chhattisgarh",
                "value": "CG"
            },
            {
                "id": "Dadra and Nagar Haveli",
                "label": "Dadra and Nagar Haveli",
                "value": "DN"
            },
            { "id": "Daman and Diu", "label": "Daman and Diu", "value": "DD" },
            { "id": "Delhi", "label": "Delhi", "value": "DL" },
            { "id": "Goa", "label": "Goa", "value": "GA" },
            { "id": "Gujarat", "label": "Gujarat", "value": "GJ" },
            { "id": "Haryana", "label": "Haryana", "value": "HR" },
            {
                "id": "Himachal Pradesh",
                "label": "Himachal Pradesh",
                "value": "HP"
            },
            {
                "id": "Jammu and Kashmir",
                "label": "Jammu and Kashmir",
                "value": "JK"
            },
            { "id": "Jharkhand", "label": "Jharkhand", "value": "JH" },
            { "id": "Karnataka", "label": "Karnataka", "value": "KA" },
            { "id": "Kerala", "label": "Kerala", "value": "KL" },
            { "id": "Ladakh", "label": "Ladakh", "value": "LA" },
            { "id": "Lakshadweep", "label": "Lakshadweep", "value": "LD" },
            {
                "id": "Madhya Pradesh",
                "label": "Madhya Pradesh",
                "value": "MP"
            },
            { "id": "Maharashtra", "label": "Maharashtra", "value": "MH" },
            { "id": "Manipur", "label": "Manipur", "value": "MN" },
            { "id": "Meghalaya", "label": "Meghalaya", "value": "ML" },
            { "id": "Mizoram", "label": "Mizoram", "value": "MZ" },
            { "id": "Nagaland", "label": "Nagaland", "value": "NL" },
            {
                "id": "Odisha",
                "alternate_names": ["OD", "Orissa"],
                "label": "Odisha",
                "value": "OR"
            },
            { "id": "Puducherry", "label": "Puducherry", "value": "PY" },
            { "id": "Punjab", "label": "Punjab", "value": "PB" },
            { "id": "Rajasthan", "label": "Rajasthan", "value": "RJ" },
            { "id": "Sikkim", "label": "Sikkim", "value": "SK" },
            { "id": "Tamil Nadu", "label": "Tamil Nadu", "value": "TN" },
            { "id": "Telangana", "label": "Telangana", "value": "TS" },
            { "id": "Tripura", "label": "Tripura", "value": "TR" },
            { "id": "Uttar Pradesh", "label": "Uttar Pradesh", "value": "UP" },
            { "id": "Uttarakhand", "label": "Uttarakhand", "value": "UK" },
            { "id": "West Bengal", "label": "West Bengal", "value": "WB" }
        ],
        "labels": { "province": "State", "zip": "PIN code" }
    },
    "ID": {
        "provinces": [
            { "id": "Aceh", "label": "Aceh", "value": "AC" },
            { "id": "Bali", "label": "Bali", "value": "BA" },
            {
                "id": "Bangka Belitung",
                "label": "Bangka–Belitung Islands",
                "value": "BB"
            },
            { "id": "Banten", "label": "Banten", "value": "BT" },
            { "id": "Bengkulu", "label": "Bengkulu", "value": "BE" },
            { "id": "Jawa Tengah", "label": "Central Java", "value": "JT" },
            {
                "id": "Kalimantan Tengah",
                "label": "Central Kalimantan",
                "value": "KT"
            },
            {
                "id": "Sulawesi Tengah",
                "label": "Central Sulawesi",
                "value": "ST"
            },
            { "id": "Jawa Timur", "label": "East Java", "value": "JI" },
            {
                "id": "Kalimantan Timur",
                "label": "East Kalimantan",
                "value": "KI"
            },
            {
                "id": "Nusa Tenggara Timur",
                "label": "East Nusa Tenggara",
                "value": "NT"
            },
            { "id": "Gorontalo", "label": "Gorontalo", "value": "GO" },
            { "id": "Jakarta", "label": "Jakarta", "value": "JK" },
            { "id": "Jambi", "label": "Jambi", "value": "JA" },
            { "id": "Lampung", "label": "Lampung", "value": "LA" },
            { "id": "Maluku", "label": "Maluku", "value": "MA" },
            {
                "id": "Kalimantan Utara",
                "label": "North Kalimantan",
                "value": "KU"
            },
            { "id": "Maluku Utara", "label": "North Maluku", "value": "MU" },
            {
                "id": "Sulawesi Utara",
                "label": "North Sulawesi",
                "value": "SA"
            },
            {
                "id": "North Sumatra",
                "alternate_names": ["Sumatra Utara"],
                "label": "North Sumatra",
                "value": "SU"
            },
            { "id": "Papua", "label": "Papua", "value": "PA" },
            { "id": "Riau", "label": "Riau", "value": "RI" },
            { "id": "Kepulauan Riau", "label": "Riau Islands", "value": "KR" },
            {
                "id": "Kalimantan Selatan",
                "label": "South Kalimantan",
                "value": "KS"
            },
            {
                "id": "Sulawesi Selatan",
                "label": "South Sulawesi",
                "value": "SN"
            },
            {
                "id": "South Sumatra",
                "alternate_names": ["Sumatra Selatan"],
                "label": "South Sumatra",
                "value": "SS"
            },
            {
                "id": "Sulawesi Tenggara",
                "label": "Southeast Sulawesi",
                "value": "SG"
            },
            { "id": "Jawa Barat", "label": "West Java", "value": "JB" },
            {
                "id": "Kalimantan Barat",
                "label": "West Kalimantan",
                "value": "KB"
            },
            {
                "id": "Nusa Tenggara Barat",
                "label": "West Nusa Tenggara",
                "value": "NB"
            },
            { "id": "Papua Barat", "label": "West Papua", "value": "PB" },
            { "id": "Sulawesi Barat", "label": "West Sulawesi", "value": "SR" },
            {
                "id": "West Sumatra",
                "alternate_names": ["Sumatra Barat"],
                "label": "West Sumatra",
                "value": "SB"
            },
            { "id": "Yogyakarta", "label": "Yogyakarta", "value": "YO" }
        ],
        "labels": { "province": "Province" }
    },
    "IR": { "labels": { "zip": "Postal code (optional)" } },
    "IQ": { "labels": { "zip": "Postal code (optional)" } },
    "IE": {
        "provinces": [
            {
                "id": "Carlow",
                "alternate_names": [
                    "Ceatharlach",
                    "Contae Cheatharlach",
                    "County Carlow",
                    "Co. Carlow"
                ],
                "label": "Carlow",
                "value": "CW"
            },
            {
                "id": "Cavan",
                "alternate_names": [
                    "An Cabhán",
                    "An Cabhan",
                    "Contae an Chabháin",
                    "Contae an Chabhain",
                    "County Cavan",
                    "Co. Cavan"
                ],
                "label": "Cavan",
                "value": "CN"
            },
            {
                "id": "Clare",
                "alternate_names": [
                    "An Clár",
                    "An Clar",
                    "Contae an Chláir",
                    "Contae an Chlair",
                    "County Clare",
                    "Co. Clare"
                ],
                "label": "Clare",
                "value": "CE"
            },
            {
                "id": "Cork",
                "alternate_names": [
                    "Corcaigh",
                    "Contae Chorcaí",
                    "Contae Chorcai",
                    "County Cork",
                    "Co. Cork"
                ],
                "label": "Cork",
                "value": "CO"
            },
            {
                "id": "Donegal",
                "alternate_names": [
                    "Dún na nGall",
                    "Dun na nGall",
                    "Contae Dhún na nGall",
                    "Contae Dhun na nGall",
                    "County Donegal",
                    "Co. Donegal"
                ],
                "label": "Donegal",
                "value": "DL"
            },
            {
                "id": "Dublin",
                "alternate_names": [
                    "Baile Átha Cliath",
                    "Baile Atha Cliath",
                    "County Dublin",
                    "Co. Dublin"
                ],
                "label": "Dublin",
                "value": "D"
            },
            {
                "id": "Galway",
                "alternate_names": [
                    "Gaillimh",
                    "Contae na Gaillimhe",
                    "County Galway",
                    "Co. Galway"
                ],
                "label": "Galway",
                "value": "G"
            },
            {
                "id": "Kerry",
                "alternate_names": [
                    "Ciarraí",
                    "Ciarrai",
                    "Contae Chiarraí",
                    "Contae Chiarrai",
                    "County Kerry",
                    "Co. Kerry"
                ],
                "label": "Kerry",
                "value": "KY"
            },
            {
                "id": "Kildare",
                "alternate_names": [
                    "Cill Dara",
                    "Contae Chill Dara",
                    "County Kildare",
                    "Co. Kildare"
                ],
                "label": "Kildare",
                "value": "KE"
            },
            {
                "id": "Kilkenny",
                "alternate_names": [
                    "Cill Chainnigh",
                    "Contae Chill Chainnigh",
                    "County Kilkenny",
                    "Co. Kilkenny"
                ],
                "label": "Kilkenny",
                "value": "KK"
            },
            {
                "id": "Laois",
                "alternate_names": [
                    "Contae Laoise",
                    "County Laois",
                    "Co. Laois"
                ],
                "label": "Laois",
                "value": "LS"
            },
            {
                "id": "Leitrim",
                "alternate_names": [
                    "Liatroim",
                    "Contae Liatroma",
                    "County Leitrim",
                    "Co. Leitrim"
                ],
                "label": "Leitrim",
                "value": "LM"
            },
            {
                "id": "Limerick",
                "alternate_names": [
                    "Luimneach",
                    "Contae Luimnigh",
                    "County Limerick",
                    "Co. Limerick"
                ],
                "label": "Limerick",
                "value": "LK"
            },
            {
                "id": "Longford",
                "alternate_names": [
                    "An Longfort",
                    "Contae an Longfoirt",
                    "County Longford",
                    "Co. Longford"
                ],
                "label": "Longford",
                "value": "LD"
            },
            {
                "id": "Louth",
                "alternate_names": [
                    "Lú",
                    "Lu",
                    "Contae Lú",
                    "Contae Lu",
                    "County Louth",
                    "Co. Louth"
                ],
                "label": "Louth",
                "value": "LH"
            },
            {
                "id": "Mayo",
                "alternate_names": [
                    "Maigh Eo",
                    "Contae Mhaigh Eo",
                    "County Mayo",
                    "Co. Mayo"
                ],
                "label": "Mayo",
                "value": "MO"
            },
            {
                "id": "Meath",
                "alternate_names": [
                    "An Mhí",
                    "An Mhi",
                    "Contae na Mí",
                    "Contae na Mi",
                    "County Meath",
                    "Co. Meath"
                ],
                "label": "Meath",
                "value": "MH"
            },
            {
                "id": "Monaghan",
                "alternate_names": [
                    "Muineachán",
                    "Muineachan",
                    "Contae Mhuineacháin",
                    "Contae Mhuineachain",
                    "County Monaghan",
                    "Co. Monaghan"
                ],
                "label": "Monaghan",
                "value": "MN"
            },
            {
                "id": "Offaly",
                "alternate_names": [
                    "Uíbh Fhailí",
                    "Uibh Fhaili",
                    "Contae Uíbh Fhailí",
                    "Contae Uibh Fhaili",
                    "County Offaly",
                    "Co. Offaly"
                ],
                "label": "Offaly",
                "value": "OY"
            },
            {
                "id": "Roscommon",
                "alternate_names": [
                    "Ros Comáin",
                    "Ros Comain",
                    "Contae Ros Comáin",
                    "Contae Ros Comain",
                    "County Roscommon",
                    "Co. Roscommon"
                ],
                "label": "Roscommon",
                "value": "RN"
            },
            {
                "id": "Sligo",
                "alternate_names": [
                    "Sligeach",
                    "Contae Shligigh",
                    "County Sligo",
                    "Co. Sligo"
                ],
                "label": "Sligo",
                "value": "SO"
            },
            {
                "id": "Tipperary",
                "alternate_names": [
                    "Tiobraid Árann",
                    "Tiobraid Arann",
                    "Contae Thiobraid Árann",
                    "Contae Thiobraid Arann",
                    "County Tipperary",
                    "Co. Tipperary"
                ],
                "label": "Tipperary",
                "value": "TA"
            },
            {
                "id": "Waterford",
                "alternate_names": [
                    "Port Láirge",
                    "Port Lairge",
                    "Contae Phort Láirge",
                    "Contae Phort Lairge",
                    "County Waterford",
                    "Co. Waterford"
                ],
                "label": "Waterford",
                "value": "WD"
            },
            {
                "id": "Westmeath",
                "alternate_names": [
                    "An Iarmhí",
                    "An Iarmhi",
                    "Contae na hIarmhí",
                    "Contae na hIarmhi",
                    "County Westmeath",
                    "Co. Westmeath"
                ],
                "label": "Westmeath",
                "value": "WH"
            },
            {
                "id": "Wexford",
                "alternate_names": [
                    "Loch Garman",
                    "Contae Loch Garman",
                    "County Wexford",
                    "Co. Wexford"
                ],
                "label": "Wexford",
                "value": "WX"
            },
            {
                "id": "Wicklow",
                "alternate_names": [
                    "Cill Mhantáin",
                    "Cill Mhantain",
                    "Contae Chill Mhantáin",
                    "Contae Chill Mhantain",
                    "County Wicklow",
                    "Co. Wicklow"
                ],
                "label": "Wicklow",
                "value": "WW"
            }
        ],
        "labels": { "province": "County" }
    },
    "IM": {},
    "IL": {},
    "IT": {
        "provinces": [
            { "id": "Agrigento", "label": "Agrigento", "value": "AG" },
            { "id": "Alessandria", "label": "Alessandria", "value": "AL" },
            { "id": "Ancona", "label": "Ancona", "value": "AN" },
            { "id": "Aosta", "label": "Aosta Valley", "value": "AO" },
            { "id": "Arezzo", "label": "Arezzo", "value": "AR" },
            { "id": "Ascoli Piceno", "label": "Ascoli Piceno", "value": "AP" },
            { "id": "Asti", "label": "Asti", "value": "AT" },
            { "id": "Avellino", "label": "Avellino", "value": "AV" },
            { "id": "Bari", "label": "Bari", "value": "BA" },
            {
                "id": "Barletta-Andria-Trani",
                "label": "Barletta-Andria-Trani",
                "value": "BT"
            },
            { "id": "Belluno", "label": "Belluno", "value": "BL" },
            { "id": "Benevento", "label": "Benevento", "value": "BN" },
            { "id": "Bergamo", "label": "Bergamo", "value": "BG" },
            { "id": "Biella", "label": "Biella", "value": "BI" },
            { "id": "Bologna", "label": "Bologna", "value": "BO" },
            { "id": "Brescia", "label": "Brescia", "value": "BS" },
            { "id": "Brindisi", "label": "Brindisi", "value": "BR" },
            { "id": "Cagliari", "label": "Cagliari", "value": "CA" },
            { "id": "Caltanissetta", "label": "Caltanissetta", "value": "CL" },
            { "id": "Campobasso", "label": "Campobasso", "value": "CB" },
            {
                "id": "Carbonia-Iglesias",
                "label": "Carbonia-Iglesias",
                "value": "CI"
            },
            { "id": "Caserta", "label": "Caserta", "value": "CE" },
            { "id": "Catania", "label": "Catania", "value": "CT" },
            { "id": "Catanzaro", "label": "Catanzaro", "value": "CZ" },
            { "id": "Chieti", "label": "Chieti", "value": "CH" },
            { "id": "Como", "label": "Como", "value": "CO" },
            { "id": "Cosenza", "label": "Cosenza", "value": "CS" },
            { "id": "Cremona", "label": "Cremona", "value": "CR" },
            { "id": "Crotone", "label": "Crotone", "value": "KR" },
            { "id": "Cuneo", "label": "Cuneo", "value": "CN" },
            { "id": "Enna", "label": "Enna", "value": "EN" },
            { "id": "Fermo", "label": "Fermo", "value": "FM" },
            { "id": "Ferrara", "label": "Ferrara", "value": "FE" },
            { "id": "Firenze", "label": "Florence", "value": "FI" },
            { "id": "Foggia", "label": "Foggia", "value": "FG" },
            {
                "id": "Forlì-Cesena",
                "alternate_names": ["Forli-Cesena"],
                "label": "Forlì-Cesena",
                "value": "FC"
            },
            { "id": "Frosinone", "label": "Frosinone", "value": "FR" },
            { "id": "Genova", "label": "Genoa", "value": "GE" },
            { "id": "Gorizia", "label": "Gorizia", "value": "GO" },
            { "id": "Grosseto", "label": "Grosseto", "value": "GR" },
            { "id": "Imperia", "label": "Imperia", "value": "IM" },
            { "id": "Isernia", "label": "Isernia", "value": "IS" },
            { "id": "La Spezia", "label": "La Spezia", "value": "SP" },
            { "id": "Latina", "label": "Latina", "value": "LT" },
            { "id": "Lecce", "label": "Lecce", "value": "LE" },
            { "id": "Lecco", "label": "Lecco", "value": "LC" },
            { "id": "Livorno", "label": "Livorno", "value": "LI" },
            { "id": "Lodi", "label": "Lodi", "value": "LO" },
            { "id": "Lucca", "label": "Lucca", "value": "LU" },
            { "id": "L'Aquila", "label": "L’Aquila", "value": "AQ" },
            { "id": "Macerata", "label": "Macerata", "value": "MC" },
            { "id": "Mantova", "label": "Mantua", "value": "MN" },
            {
                "id": "Massa-Carrara",
                "label": "Massa and Carrara",
                "value": "MS"
            },
            { "id": "Matera", "label": "Matera", "value": "MT" },
            {
                "id": "Medio Campidano",
                "label": "Medio Campidano",
                "value": "VS"
            },
            { "id": "Messina", "label": "Messina", "value": "ME" },
            { "id": "Milano", "label": "Milan", "value": "MI" },
            { "id": "Modena", "label": "Modena", "value": "MO" },
            {
                "id": "Monza e Brianza",
                "label": "Monza and Brianza",
                "value": "MB"
            },
            { "id": "Napoli", "label": "Naples", "value": "NA" },
            { "id": "Novara", "label": "Novara", "value": "NO" },
            { "id": "Nuoro", "label": "Nuoro", "value": "NU" },
            { "id": "Ogliastra", "label": "Ogliastra", "value": "OG" },
            { "id": "Olbia-Tempio", "label": "Olbia-Tempio", "value": "OT" },
            { "id": "Oristano", "label": "Oristano", "value": "OR" },
            { "id": "Padova", "label": "Padua", "value": "PD" },
            { "id": "Palermo", "label": "Palermo", "value": "PA" },
            { "id": "Parma", "label": "Parma", "value": "PR" },
            { "id": "Pavia", "label": "Pavia", "value": "PV" },
            { "id": "Perugia", "label": "Perugia", "value": "PG" },
            {
                "id": "Pesaro e Urbino",
                "label": "Pesaro and Urbino",
                "value": "PU"
            },
            { "id": "Pescara", "label": "Pescara", "value": "PE" },
            { "id": "Piacenza", "label": "Piacenza", "value": "PC" },
            { "id": "Pisa", "label": "Pisa", "value": "PI" },
            { "id": "Pistoia", "label": "Pistoia", "value": "PT" },
            { "id": "Pordenone", "label": "Pordenone", "value": "PN" },
            { "id": "Potenza", "label": "Potenza", "value": "PZ" },
            { "id": "Prato", "label": "Prato", "value": "PO" },
            { "id": "Ragusa", "label": "Ragusa", "value": "RG" },
            { "id": "Ravenna", "label": "Ravenna", "value": "RA" },
            {
                "id": "Reggio Calabria",
                "alternate_names": ["Calabria"],
                "label": "Reggio Calabria",
                "value": "RC"
            },
            { "id": "Reggio Emilia", "label": "Reggio Emilia", "value": "RE" },
            { "id": "Rieti", "label": "Rieti", "value": "RI" },
            { "id": "Rimini", "label": "Rimini", "value": "RN" },
            { "id": "Roma", "label": "Rome", "value": "RM" },
            { "id": "Rovigo", "label": "Rovigo", "value": "RO" },
            { "id": "Salerno", "label": "Salerno", "value": "SA" },
            { "id": "Sassari", "label": "Sassari", "value": "SS" },
            { "id": "Savona", "label": "Savona", "value": "SV" },
            { "id": "Siena", "label": "Siena", "value": "SI" },
            { "id": "Sondrio", "label": "Sondrio", "value": "SO" },
            { "id": "Bolzano", "label": "South Tyrol", "value": "BZ" },
            { "id": "Siracusa", "label": "Syracuse", "value": "SR" },
            { "id": "Taranto", "label": "Taranto", "value": "TA" },
            { "id": "Teramo", "label": "Teramo", "value": "TE" },
            { "id": "Terni", "label": "Terni", "value": "TR" },
            { "id": "Trapani", "label": "Trapani", "value": "TP" },
            { "id": "Trento", "label": "Trentino", "value": "TN" },
            { "id": "Treviso", "label": "Treviso", "value": "TV" },
            { "id": "Trieste", "label": "Trieste", "value": "TS" },
            { "id": "Torino", "label": "Turin", "value": "TO" },
            { "id": "Udine", "label": "Udine", "value": "UD" },
            { "id": "Varese", "label": "Varese", "value": "VA" },
            { "id": "Venezia", "label": "Venice", "value": "VE" },
            {
                "id": "Verbano-Cusio-Ossola",
                "label": "Verbano-Cusio-Ossola",
                "value": "VB"
            },
            { "id": "Vercelli", "label": "Vercelli", "value": "VC" },
            { "id": "Verona", "label": "Verona", "value": "VR" },
            { "id": "Vibo Valentia", "label": "Vibo Valentia", "value": "VV" },
            { "id": "Vicenza", "label": "Vicenza", "value": "VI" },
            { "id": "Viterbo", "label": "Viterbo", "value": "VT" }
        ],
        "labels": {
            "address1": "Street and house number",
            "province": "Province"
        }
    },
    "JM": {},
    "JP": {
        "provinces": [
            {
                "id": "Hokkaidō",
                "label": "Hokkaido",
                "alternate_names": [
                    "Hokkaido",
                    "Hokkaido Prefecture",
                    "北海道"
                ],
                "value": "JP-01"
            },
            {
                "id": "Aomori",
                "alternate_names": [
                    "Aomori Prefecture",
                    "Aomori-ken",
                    "青森県",
                    "青森"
                ],
                "label": "Aomori",
                "value": "JP-02"
            },
            {
                "id": "Iwate",
                "alternate_names": [
                    "Iwate Prefecture",
                    "Iwate-ken",
                    "岩手県",
                    "岩手"
                ],
                "label": "Iwate",
                "value": "JP-03"
            },
            {
                "id": "Miyagi",
                "alternate_names": [
                    "Miyagi Prefecture",
                    "Miyagi-ken",
                    "宮城県",
                    "宮城"
                ],
                "label": "Miyagi",
                "value": "JP-04"
            },
            {
                "id": "Akita",
                "alternate_names": [
                    "Akita Prefecture",
                    "Akita-ken",
                    "秋田県",
                    "秋田"
                ],
                "label": "Akita",
                "value": "JP-05"
            },
            {
                "id": "Yamagata",
                "alternate_names": [
                    "Yamagata Prefecture",
                    "Yamagata-ken",
                    "山形県",
                    "山形"
                ],
                "label": "Yamagata",
                "value": "JP-06"
            },
            {
                "id": "Fukushima",
                "alternate_names": [
                    "Fukushima Prefecture",
                    "Fukushima-ken",
                    "福島県",
                    "福島"
                ],
                "label": "Fukushima",
                "value": "JP-07"
            },
            {
                "id": "Ibaraki",
                "alternate_names": [
                    "Ibaraki Prefecture",
                    "Ibaraki-ken",
                    "茨城県",
                    "茨城"
                ],
                "label": "Ibaraki",
                "value": "JP-08"
            },
            {
                "id": "Tochigi",
                "alternate_names": [
                    "Tochigi Prefecture",
                    "Tochigi-ken",
                    "栃木県",
                    "栃木"
                ],
                "label": "Tochigi",
                "value": "JP-09"
            },
            {
                "id": "Gunma",
                "alternate_names": [
                    "Gunma Prefecture",
                    "Gunma-ken",
                    "群馬県",
                    "群馬"
                ],
                "label": "Gunma",
                "value": "JP-10"
            },
            {
                "id": "Saitama",
                "alternate_names": [
                    "Saitama Prefecture",
                    "Saitama-ken",
                    "埼玉県",
                    "埼玉"
                ],
                "label": "Saitama",
                "value": "JP-11"
            },
            {
                "id": "Chiba",
                "alternate_names": [
                    "Chiba Prefecture",
                    "Chiba-ken",
                    "千葉県",
                    "千葉"
                ],
                "label": "Chiba",
                "value": "JP-12"
            },
            {
                "id": "Tōkyō",
                "label": "Tokyo",
                "alternate_names": [
                    "Tokyo",
                    "Tokyo Prefecture",
                    "Tōkyō-to",
                    "Tokyo-to",
                    "東京都",
                    "東京"
                ],
                "value": "JP-13"
            },
            {
                "id": "Kanagawa",
                "alternate_names": [
                    "Kanagawa Prefecture",
                    "Kanagawa-ken",
                    "神奈川県",
                    "神奈川"
                ],
                "label": "Kanagawa",
                "value": "JP-14"
            },
            {
                "id": "Niigata",
                "alternate_names": [
                    "Niigata Prefecture",
                    "Niigata-ken",
                    "新潟県",
                    "新潟"
                ],
                "label": "Niigata",
                "value": "JP-15"
            },
            {
                "id": "Toyama",
                "alternate_names": [
                    "Toyama Prefecture",
                    "Toyama-ken",
                    "富山県",
                    "富山"
                ],
                "label": "Toyama",
                "value": "JP-16"
            },
            {
                "id": "Ishikawa",
                "alternate_names": [
                    "Ishikawa Prefecture",
                    "Ishikawa-ken",
                    "石川県",
                    "石川"
                ],
                "label": "Ishikawa",
                "value": "JP-17"
            },
            {
                "id": "Fukui",
                "alternate_names": [
                    "Fukui Prefecture",
                    "Fukui-ken",
                    "福井県",
                    "福井"
                ],
                "label": "Fukui",
                "value": "JP-18"
            },
            {
                "id": "Yamanashi",
                "alternate_names": [
                    "Yamanashi Prefecture",
                    "Yamanashi-ken",
                    "山梨県",
                    "山梨"
                ],
                "label": "Yamanashi",
                "value": "JP-19"
            },
            {
                "id": "Nagano",
                "alternate_names": [
                    "Nagano Prefecture",
                    "Nagano-ken",
                    "長野県",
                    "長野"
                ],
                "label": "Nagano",
                "value": "JP-20"
            },
            {
                "id": "Gifu",
                "alternate_names": [
                    "Gifu Prefecture",
                    "Gifu-ken",
                    "岐阜県",
                    "岐阜"
                ],
                "label": "Gifu",
                "value": "JP-21"
            },
            {
                "id": "Shizuoka",
                "alternate_names": [
                    "Shizuoka Prefecture",
                    "Shizuoka-ken",
                    "静岡県",
                    "静岡"
                ],
                "label": "Shizuoka",
                "value": "JP-22"
            },
            {
                "id": "Aichi",
                "alternate_names": [
                    "Aichi Prefecture",
                    "Aichi-ken",
                    "愛知県",
                    "愛知"
                ],
                "label": "Aichi",
                "value": "JP-23"
            },
            {
                "id": "Mie",
                "alternate_names": [
                    "Mie Prefecture",
                    "Mie-ken",
                    "三重県",
                    "三重"
                ],
                "label": "Mie",
                "value": "JP-24"
            },
            {
                "id": "Shiga",
                "alternate_names": [
                    "Shiga Prefecture",
                    "Shiga-ken",
                    "滋賀県",
                    "滋賀"
                ],
                "label": "Shiga",
                "value": "JP-25"
            },
            {
                "id": "Kyōto",
                "label": "Kyoto",
                "alternate_names": [
                    "Kyoto",
                    "Kyoto Prefecture",
                    "Kyōto-fu",
                    "Kyoto-fu",
                    "京都府",
                    "京都"
                ],
                "value": "JP-26"
            },
            {
                "id": "Ōsaka",
                "label": "Osaka",
                "alternate_names": [
                    "Osaka",
                    "Osaka Prefecture",
                    "Ōsaka-fu",
                    "Osaka-fu",
                    "大阪府",
                    "大阪"
                ],
                "value": "JP-27"
            },
            {
                "id": "Hyōgo",
                "label": "Hyogo",
                "alternate_names": [
                    "Hyogo",
                    "Hyogo Prefecture",
                    "Hyōgo-ken",
                    "Hyogo-ken",
                    "兵庫県",
                    "兵庫"
                ],
                "value": "JP-28"
            },
            {
                "id": "Nara",
                "alternate_names": [
                    "Nara Prefecture",
                    "Nara-ken",
                    "奈良県",
                    "奈良"
                ],
                "label": "Nara",
                "value": "JP-29"
            },
            {
                "id": "Wakayama",
                "alternate_names": [
                    "Wakayama Prefecture",
                    "Wakayama-ken",
                    "和歌山県",
                    "和歌山"
                ],
                "label": "Wakayama",
                "value": "JP-30"
            },
            {
                "id": "Tottori",
                "alternate_names": [
                    "Tottori Prefecture",
                    "Tottori-ken",
                    "鳥取県",
                    "鳥取"
                ],
                "label": "Tottori",
                "value": "JP-31"
            },
            {
                "id": "Shimane",
                "alternate_names": [
                    "Shimane Prefecture",
                    "Shimane-ken",
                    "島根県",
                    "島根"
                ],
                "label": "Shimane",
                "value": "JP-32"
            },
            {
                "id": "Okayama",
                "alternate_names": [
                    "Okayama Prefecture",
                    "Okayama-ken",
                    "岡山県",
                    "岡山"
                ],
                "label": "Okayama",
                "value": "JP-33"
            },
            {
                "id": "Hiroshima",
                "alternate_names": [
                    "Hiroshima Prefecture",
                    "Hiroshima-ken",
                    "広島県",
                    "広島"
                ],
                "label": "Hiroshima",
                "value": "JP-34"
            },
            {
                "id": "Yamaguchi",
                "alternate_names": [
                    "Yamaguchi Prefecture",
                    "Yamaguchi-ken",
                    "山口県",
                    "山口"
                ],
                "label": "Yamaguchi",
                "value": "JP-35"
            },
            {
                "id": "Tokushima",
                "alternate_names": [
                    "Tokushima Prefecture",
                    "Tokushima-ken",
                    "徳島県",
                    "徳島"
                ],
                "label": "Tokushima",
                "value": "JP-36"
            },
            {
                "id": "Kagawa",
                "alternate_names": [
                    "Kagawa Prefecture",
                    "Kagawa-ken",
                    "香川県",
                    "香川"
                ],
                "label": "Kagawa",
                "value": "JP-37"
            },
            {
                "id": "Ehime",
                "alternate_names": [
                    "Ehime Prefecture",
                    "Ehime-ken",
                    "愛媛県",
                    "愛媛"
                ],
                "label": "Ehime",
                "value": "JP-38"
            },
            {
                "id": "Kōchi",
                "label": "Kochi",
                "alternate_names": [
                    "Kochi",
                    "Kochi Prefecture",
                    "Kōchi-ken",
                    "Kochi-ken",
                    "高知県",
                    "高知"
                ],
                "value": "JP-39"
            },
            {
                "id": "Fukuoka",
                "alternate_names": [
                    "Fukuoka Prefecture",
                    "Fukuoka-ken",
                    "福岡県",
                    "福岡"
                ],
                "label": "Fukuoka",
                "value": "JP-40"
            },
            {
                "id": "Saga",
                "alternate_names": [
                    "Saga Prefecture",
                    "Saga-ken",
                    "佐賀県",
                    "佐賀"
                ],
                "label": "Saga",
                "value": "JP-41"
            },
            {
                "id": "Nagasaki",
                "alternate_names": [
                    "Nagasaki Prefecture",
                    "Nagasaki-ken",
                    "長崎県",
                    "長崎"
                ],
                "label": "Nagasaki",
                "value": "JP-42"
            },
            {
                "id": "Kumamoto",
                "alternate_names": [
                    "Kumamoto Prefecture",
                    "Kumamoto-ken",
                    "熊本県",
                    "熊本"
                ],
                "label": "Kumamoto",
                "value": "JP-43"
            },
            {
                "id": "Ōita",
                "label": "Oita",
                "alternate_names": [
                    "Oita",
                    "Oita Prefecture",
                    "Ōita-ken",
                    "Oita-ken",
                    "大分県",
                    "大分"
                ],
                "value": "JP-44"
            },
            {
                "id": "Miyazaki",
                "alternate_names": [
                    "Miyazaki Prefecture",
                    "Miyazaki-ken",
                    "宮崎県",
                    "宮崎"
                ],
                "label": "Miyazaki",
                "value": "JP-45"
            },
            {
                "id": "Kagoshima",
                "alternate_names": [
                    "Kagoshima Prefecture",
                    "Kagoshima-ken",
                    "鹿児島県",
                    "鹿児島"
                ],
                "label": "Kagoshima",
                "value": "JP-46"
            },
            {
                "id": "Okinawa",
                "alternate_names": [
                    "Okinawa Prefecture",
                    "Okinawa-ken",
                    "沖縄県",
                    "沖縄"
                ],
                "label": "Okinawa",
                "value": "JP-47"
            }
        ],
        "labels": { "city": "City/ward/town/village", "province": "Prefecture" }
    },
    "JE": {},
    "JO": { "labels": { "zip": "Postal code (optional)" } },
    "KZ": { "labels": { "zip": "Postal code (optional)" } },
    "KE": { "labels": { "zip": "Postal code (optional)" } },
    "KI": { "labels": { "zip": "Postal code (optional)" } },
    "KP": { "labels": { "zip": "Postal code (optional)" } },
    "XK": {},
    "KW": { "labels": { "zip": "Postal code (optional)" } },
    "KG": { "labels": { "zip": "Postal code (optional)" } },
    "LA": { "labels": { "zip": "Postal code (optional)" } },
    "LV": {},
    "LB": { "labels": { "zip": "Postal code (optional)" } },
    "LS": { "labels": { "zip": "Postal code (optional)" } },
    "LR": { "labels": { "zip": "Postal code (optional)" } },
    "LY": { "labels": { "zip": "Postal code (optional)" } },
    "LI": {},
    "LT": {},
    "LU": {},
    "MO": { "labels": { "city": "Area" } },
    "MG": {},
    "MW": { "labels": { "zip": "Postal code (optional)" } },
    "MY": {
        "provinces": [
            { "id": "Johor", "label": "Johor", "value": "JHR" },
            { "id": "Kedah", "label": "Kedah", "value": "KDH" },
            { "id": "Kelantan", "label": "Kelantan", "value": "KTN" },
            { "id": "Kuala Lumpur", "label": "Kuala Lumpur", "value": "KUL" },
            { "id": "Labuan", "label": "Labuan", "value": "LBN" },
            { "id": "Melaka", "label": "Malacca", "value": "MLK" },
            {
                "id": "Negeri Sembilan",
                "label": "Negeri Sembilan",
                "value": "NSN"
            },
            { "id": "Pahang", "label": "Pahang", "value": "PHG" },
            {
                "id": "Penang",
                "alternate_names": ["Pulau Pinang"],
                "label": "Penang",
                "value": "PNG"
            },
            { "id": "Perak", "label": "Perak", "value": "PRK" },
            { "id": "Perlis", "label": "Perlis", "value": "PLS" },
            { "id": "Putrajaya", "label": "Putrajaya", "value": "PJY" },
            { "id": "Sabah", "label": "Sabah", "value": "SBH" },
            { "id": "Sarawak", "label": "Sarawak", "value": "SWK" },
            { "id": "Selangor", "label": "Selangor", "value": "SGR" },
            { "id": "Terengganu", "label": "Terengganu", "value": "TRG" }
        ],
        "labels": { "province": "State/territory", "zip": "Postcode" }
    },
    "MV": { "labels": { "zip": "Postal code (optional)" } },
    "ML": {},
    "MT": {},
    "MQ": {},
    "MR": {},
    "MU": { "labels": { "zip": "Postal code (optional)" } },
    "YT": {},
    "MX": {
        "provinces": [
            {
                "id": "Aguascalientes",
                "label": "Aguascalientes",
                "value": "AGS"
            },
            {
                "id": "Baja California",
                "label": "Baja California",
                "value": "BC"
            },
            {
                "id": "Baja California Sur",
                "label": "Baja California Sur",
                "value": "BCS"
            },
            { "id": "Campeche", "label": "Campeche", "value": "CAMP" },
            { "id": "Chiapas", "label": "Chiapas", "value": "CHIS" },
            { "id": "Chihuahua", "label": "Chihuahua", "value": "CHIH" },
            {
                "id": "Ciudad de México",
                "label": "Ciudad de Mexico",
                "alternate_names": ["Ciudad de Mexico", "CDMX"],
                "value": "DF"
            },
            { "id": "Coahuila", "label": "Coahuila", "value": "COAH" },
            { "id": "Colima", "label": "Colima", "value": "COL" },
            { "id": "Durango", "label": "Durango", "value": "DGO" },
            { "id": "Guanajuato", "label": "Guanajuato", "value": "GTO" },
            { "id": "Guerrero", "label": "Guerrero", "value": "GRO" },
            { "id": "Hidalgo", "label": "Hidalgo", "value": "HGO" },
            {
                "id": "Jalisco",
                "alternate_names": ["Jal."],
                "label": "Jalisco",
                "value": "JAL"
            },
            {
                "id": "México",
                "label": "Mexico State",
                "alternate_names": ["Mexico"],
                "value": "MEX"
            },
            {
                "id": "Michoacán",
                "alternate_names": ["Michoacan"],
                "label": "Michoacán",
                "value": "MICH"
            },
            { "id": "Morelos", "label": "Morelos", "value": "MOR" },
            { "id": "Nayarit", "label": "Nayarit", "value": "NAY" },
            {
                "id": "Nuevo León",
                "alternate_names": ["Nuevo Leon"],
                "label": "Nuevo León",
                "value": "NL"
            },
            { "id": "Oaxaca", "label": "Oaxaca", "value": "OAX" },
            { "id": "Puebla", "label": "Puebla", "value": "PUE" },
            {
                "id": "Querétaro",
                "alternate_names": ["Queretaro"],
                "label": "Querétaro",
                "value": "QRO"
            },
            { "id": "Quintana Roo", "label": "Quintana Roo", "value": "Q ROO" },
            {
                "id": "San Luis Potosí",
                "alternate_names": ["San Luis Potosi"],
                "label": "San Luis Potosí",
                "value": "SLP"
            },
            { "id": "Sinaloa", "label": "Sinaloa", "value": "SIN" },
            { "id": "Sonora", "label": "Sonora", "value": "SON" },
            { "id": "Tabasco", "label": "Tabasco", "value": "TAB" },
            { "id": "Tamaulipas", "label": "Tamaulipas", "value": "TAMPS" },
            { "id": "Tlaxcala", "label": "Tlaxcala", "value": "TLAX" },
            { "id": "Veracruz", "label": "Veracruz", "value": "VER" },
            {
                "id": "Yucatán",
                "alternate_names": ["Yucatan"],
                "label": "Yucatán",
                "value": "YUC"
            },
            { "id": "Zacatecas", "label": "Zacatecas", "value": "ZAC" }
        ],
        "labels": { "address1": "Street and house number", "province": "State" }
    },
    "MD": { "labels": { "zip": "Postal code (optional)" } },
    "MC": { "labels": { "city": "Ward" } },
    "MN": {},
    "ME": {},
    "MS": {},
    "MA": { "labels": { "zip": "Postal code (optional)" } },
    "MZ": { "labels": { "zip": "Postal code (optional)" } },
    "MM": { "labels": { "zip": "Postal code (optional)" } },
    "NA": { "labels": { "zip": "Postal code (optional)" } },
    "NR": {},
    "NP": { "labels": { "zip": "Postal code (optional)" } },
    "NL": { "labels": { "address1": "Street and house number" } },
    "AN": { "labels": { "zip": "Postal code (optional)" } },
    "NC": {},
    "NZ": {
        "provinces": [
            { "id": "Auckland", "label": "Auckland", "value": "AUK" },
            { "id": "Bay of Plenty", "label": "Bay of Plenty", "value": "BOP" },
            { "id": "Canterbury", "label": "Canterbury", "value": "CAN" },
            {
                "id": "Chatham Islands",
                "label": "Chatham Islands",
                "value": "CIT"
            },
            { "id": "Gisborne", "label": "Gisborne", "value": "GIS" },
            { "id": "Hawke's Bay", "label": "Hawke’s Bay", "value": "HKB" },
            {
                "id": "Manawatu-Wanganui",
                "label": "Manawatu-Wanganui",
                "value": "MWT"
            },
            { "id": "Marlborough", "label": "Marlborough", "value": "MBH" },
            { "id": "Nelson", "label": "Nelson", "value": "NSN" },
            { "id": "Northland", "label": "Northland", "value": "NTL" },
            { "id": "Otago", "label": "Otago", "value": "OTA" },
            { "id": "Southland", "label": "Southland", "value": "STL" },
            { "id": "Taranaki", "label": "Taranaki", "value": "TKI" },
            { "id": "Tasman", "label": "Tasman", "value": "TAS" },
            { "id": "Waikato", "label": "Waikato", "value": "WKO" },
            { "id": "Wellington", "label": "Wellington", "value": "WGN" },
            { "id": "West Coast", "label": "West Coast", "value": "WTC" }
        ],
        "labels": { "province": "Region" }
    },
    "NI": { "labels": { "zip": "Postal code (optional)" } },
    "NE": { "labels": { "zip": "Postal code (optional)" } },
    "NG": {
        "provinces": [
            { "id": "Abia", "label": "Abia", "value": "AB" },
            { "id": "Adamawa", "label": "Adamawa", "value": "AD" },
            { "id": "Akwa Ibom", "label": "Akwa Ibom", "value": "AK" },
            { "id": "Anambra", "label": "Anambra", "value": "AN" },
            { "id": "Bauchi", "label": "Bauchi", "value": "BA" },
            { "id": "Bayelsa", "label": "Bayelsa", "value": "BY" },
            { "id": "Benue", "label": "Benue", "value": "BE" },
            { "id": "Borno", "label": "Borno", "value": "BO" },
            { "id": "Cross River", "label": "Cross River", "value": "CR" },
            { "id": "Delta", "label": "Delta", "value": "DE" },
            { "id": "Ebonyi", "label": "Ebonyi", "value": "EB" },
            { "id": "Edo", "label": "Edo", "value": "ED" },
            { "id": "Ekiti", "label": "Ekiti", "value": "EK" },
            { "id": "Enugu", "label": "Enugu", "value": "EN" },
            {
                "id": "Abuja Federal Capital Territory",
                "label": "Federal Capital Territory",
                "alternate_names": ["Abuja"],
                "value": "FC"
            },
            { "id": "Gombe", "label": "Gombe", "value": "GO" },
            { "id": "Imo", "label": "Imo", "value": "IM" },
            { "id": "Jigawa", "label": "Jigawa", "value": "JI" },
            { "id": "Kaduna", "label": "Kaduna", "value": "KD" },
            { "id": "Kano", "label": "Kano", "value": "KN" },
            { "id": "Katsina", "label": "Katsina", "value": "KT" },
            { "id": "Kebbi", "label": "Kebbi", "value": "KE" },
            { "id": "Kogi", "label": "Kogi", "value": "KO" },
            { "id": "Kwara", "label": "Kwara", "value": "KW" },
            { "id": "Lagos", "label": "Lagos", "value": "LA" },
            { "id": "Nasarawa", "label": "Nasarawa", "value": "NA" },
            { "id": "Niger", "label": "Niger", "value": "NI" },
            { "id": "Ogun", "label": "Ogun", "value": "OG" },
            { "id": "Ondo", "label": "Ondo", "value": "ON" },
            { "id": "Osun", "label": "Osun", "value": "OS" },
            { "id": "Oyo", "label": "Oyo", "value": "OY" },
            { "id": "Plateau", "label": "Plateau", "value": "PL" },
            { "id": "Rivers", "label": "Rivers", "value": "RI" },
            { "id": "Sokoto", "label": "Sokoto", "value": "SO" },
            { "id": "Taraba", "label": "Taraba", "value": "TA" },
            { "id": "Yobe", "label": "Yobe", "value": "YO" },
            { "id": "Zamfara", "label": "Zamfara", "value": "ZA" }
        ],
        "labels": { "province": "State", "zip": "Postal code (optional)" }
    },
    "NU": {},
    "NF": {},
    "MK": {},
    "NO": { "labels": { "address1": "Street and house number" } },
    "OM": { "labels": { "zip": "Postal code (optional)" } },
    "PK": {},
    "PS": { "labels": { "zip": "Postal code (optional)" } },
    "PA": {
        "provinces": [
            {
                "id": "Bocas del Toro",
                "label": "Bocas del Toro",
                "value": "PA-1"
            },
            {
                "id": "Chiriquí",
                "alternate_names": ["Chiriqui"],
                "label": "Chiriquí",
                "value": "PA-4"
            },
            {
                "id": "Coclé",
                "alternate_names": ["Cocle"],
                "label": "Coclé",
                "value": "PA-2"
            },
            {
                "id": "Colón",
                "alternate_names": ["Colon"],
                "label": "Colón",
                "value": "PA-3"
            },
            {
                "id": "Darién",
                "alternate_names": ["Darien"],
                "label": "Darién",
                "value": "PA-5"
            },
            {
                "id": "Emberá",
                "alternate_names": ["Embera"],
                "label": "Emberá",
                "value": "PA-EM"
            },
            { "id": "Kuna Yala", "label": "Guna Yala", "value": "PA-KY" },
            { "id": "Herrera", "label": "Herrera", "value": "PA-6" },
            { "id": "Los Santos", "label": "Los Santos", "value": "PA-7" },
            {
                "id": "Ngöbe-Buglé",
                "alternate_names": ["Ngobe-Bugle"],
                "label": "Ngöbe-Buglé",
                "value": "PA-NB"
            },
            {
                "id": "Panamá",
                "alternate_names": ["Panama"],
                "label": "Panamá",
                "value": "PA-8"
            },
            { "id": "Veraguas", "label": "Veraguas", "value": "PA-9" },
            {
                "id": "Panamá Oeste",
                "label": "West Panamá",
                "alternate_names": ["Panama Oeste"],
                "value": "PA-10"
            }
        ],
        "labels": { "zip": "Postal code (optional)", "province": "Region" }
    },
    "PG": { "labels": { "zip": "Postal code (optional)" } },
    "PY": { "labels": { "zip": "Postal code (optional)" } },
    "PE": {
        "provinces": [
            { "id": "Amazonas", "label": "Amazonas", "value": "PE-AMA" },
            {
                "id": "Áncash",
                "label": "Ancash",
                "alternate_names": ["Ancash", "Ancash"],
                "value": "PE-ANC"
            },
            {
                "id": "Apurímac",
                "alternate_names": ["Apurimac", "Apurimac"],
                "label": "Apurímac",
                "value": "PE-APU"
            },
            { "id": "Arequipa", "label": "Arequipa", "value": "PE-ARE" },
            { "id": "Ayacucho", "label": "Ayacucho", "value": "PE-AYA" },
            { "id": "Cajamarca", "label": "Cajamarca", "value": "PE-CAJ" },
            { "id": "Cuzco", "label": "Cusco", "value": "PE-CUS" },
            { "id": "Callao", "label": "El Callao", "value": "PE-CAL" },
            {
                "id": "Huancavelica",
                "label": "Huancavelica",
                "value": "PE-HUV"
            },
            {
                "id": "Huánuco",
                "alternate_names": ["Huanuco", "Huanuco"],
                "label": "Huánuco",
                "value": "PE-HUC"
            },
            { "id": "Ica", "label": "Ica", "value": "PE-ICA" },
            {
                "id": "Junín",
                "alternate_names": ["Junin", "Junin"],
                "label": "Junín",
                "value": "PE-JUN"
            },
            { "id": "La Libertad", "label": "La Libertad", "value": "PE-LAL" },
            { "id": "Lambayeque", "label": "Lambayeque", "value": "PE-LAM" },
            {
                "id": "Lima (departamento)",
                "label": "Lima (Department)",
                "value": "PE-LIM"
            },
            {
                "id": "Lima (provincia)",
                "label": "Lima (Metropolitan)",
                "alternate_names": ["Provincia de Lima"],
                "value": "PE-LMA"
            },
            { "id": "Loreto", "label": "Loreto", "value": "PE-LOR" },
            {
                "id": "Madre de Dios",
                "label": "Madre de Dios",
                "value": "PE-MDD"
            },
            { "id": "Moquegua", "label": "Moquegua", "value": "PE-MOQ" },
            { "id": "Pasco", "label": "Pasco", "value": "PE-PAS" },
            { "id": "Piura", "label": "Piura", "value": "PE-PIU" },
            { "id": "Puno", "label": "Puno", "value": "PE-PUN" },
            {
                "id": "San Martín",
                "alternate_names": ["San Martin", "San Martin"],
                "label": "San Martín",
                "value": "PE-SAM"
            },
            { "id": "Tacna", "label": "Tacna", "value": "PE-TAC" },
            { "id": "Tumbes", "label": "Tumbes", "value": "PE-TUM" },
            { "id": "Ucayali", "label": "Ucayali", "value": "PE-UCA" }
        ],
        "labels": { "zip": "Postal code (optional)", "province": "Region" }
    },
    "PH": {
        "provinces": [
            { "id": "Abra", "label": "Abra", "value": "PH-ABR" },
            {
                "id": "Agusan del Norte",
                "label": "Agusan del Norte",
                "value": "PH-AGN"
            },
            {
                "id": "Agusan del Sur",
                "label": "Agusan del Sur",
                "value": "PH-AGS"
            },
            { "id": "Aklan", "label": "Aklan", "value": "PH-AKL" },
            { "id": "Albay", "label": "Albay", "value": "PH-ALB" },
            { "id": "Antique", "label": "Antique", "value": "PH-ANT" },
            { "id": "Apayao", "label": "Apayao", "value": "PH-APA" },
            { "id": "Aurora", "label": "Aurora", "value": "PH-AUR" },
            { "id": "Basilan", "label": "Basilan", "value": "PH-BAS" },
            { "id": "Bataan", "label": "Bataan", "value": "PH-BAN" },
            { "id": "Batanes", "label": "Batanes", "value": "PH-BTN" },
            { "id": "Batangas", "label": "Batangas", "value": "PH-BTG" },
            { "id": "Benguet", "label": "Benguet", "value": "PH-BEN" },
            { "id": "Biliran", "label": "Biliran", "value": "PH-BIL" },
            { "id": "Bohol", "label": "Bohol", "value": "PH-BOH" },
            { "id": "Bukidnon", "label": "Bukidnon", "value": "PH-BUK" },
            { "id": "Bulacan", "label": "Bulacan", "value": "PH-BUL" },
            { "id": "Cagayan", "label": "Cagayan", "value": "PH-CAG" },
            {
                "id": "Camarines Norte",
                "label": "Camarines Norte",
                "value": "PH-CAN"
            },
            {
                "id": "Camarines Sur",
                "label": "Camarines Sur",
                "value": "PH-CAS"
            },
            { "id": "Camiguin", "label": "Camiguin", "value": "PH-CAM" },
            { "id": "Capiz", "label": "Capiz", "value": "PH-CAP" },
            { "id": "Catanduanes", "label": "Catanduanes", "value": "PH-CAT" },
            { "id": "Cavite", "label": "Cavite", "value": "PH-CAV" },
            { "id": "Cebu", "label": "Cebu", "value": "PH-CEB" },
            {
                "id": "Davao de Oro",
                "label": "Compostela Valley",
                "value": "PH-COM"
            },
            { "id": "Cotabato", "label": "Cotabato", "value": "PH-NCO" },
            {
                "id": "Davao Occidental",
                "label": "Davao Occidental",
                "value": "PH-DVO"
            },
            {
                "id": "Davao Oriental",
                "label": "Davao Oriental",
                "value": "PH-DAO"
            },
            {
                "id": "Davao del Norte",
                "label": "Davao del Norte",
                "value": "PH-DAV"
            },
            {
                "id": "Davao del Sur",
                "label": "Davao del Sur",
                "value": "PH-DAS"
            },
            {
                "id": "Dinagat Islands",
                "label": "Dinagat Islands",
                "value": "PH-DIN"
            },
            {
                "id": "Eastern Samar",
                "label": "Eastern Samar",
                "value": "PH-EAS"
            },
            { "id": "Guimaras", "label": "Guimaras", "value": "PH-GUI" },
            { "id": "Ifugao", "label": "Ifugao", "value": "PH-IFU" },
            {
                "id": "Ilocos Norte",
                "label": "Ilocos Norte",
                "value": "PH-ILN"
            },
            { "id": "Ilocos Sur", "label": "Ilocos Sur", "value": "PH-ILS" },
            { "id": "Iloilo", "label": "Iloilo", "value": "PH-ILI" },
            { "id": "Isabela", "label": "Isabela", "value": "PH-ISA" },
            { "id": "Kalinga", "label": "Kalinga", "value": "PH-KAL" },
            { "id": "La Union", "label": "La Union", "value": "PH-LUN" },
            { "id": "Laguna", "label": "Laguna", "value": "PH-LAG" },
            {
                "id": "Lanao del Norte",
                "label": "Lanao del Norte",
                "value": "PH-LAN"
            },
            {
                "id": "Lanao del Sur",
                "label": "Lanao del Sur",
                "value": "PH-LAS"
            },
            { "id": "Leyte", "label": "Leyte", "value": "PH-LEY" },
            { "id": "Maguindanao", "label": "Maguindanao", "value": "PH-MAG" },
            { "id": "Marinduque", "label": "Marinduque", "value": "PH-MAD" },
            { "id": "Masbate", "label": "Masbate", "value": "PH-MAS" },
            { "id": "Metro Manila", "label": "Metro Manila", "value": "PH-00" },
            {
                "id": "Misamis Occidental",
                "label": "Misamis Occidental",
                "value": "PH-MSC"
            },
            {
                "id": "Misamis Oriental",
                "label": "Misamis Oriental",
                "value": "PH-MSR"
            },
            {
                "id": "Mountain Province",
                "label": "Mountain",
                "value": "PH-MOU"
            },
            {
                "id": "Negros Occidental",
                "label": "Negros Occidental",
                "value": "PH-NEC"
            },
            {
                "id": "Negros Oriental",
                "label": "Negros Oriental",
                "value": "PH-NER"
            },
            {
                "id": "Northern Samar",
                "label": "Northern Samar",
                "value": "PH-NSA"
            },
            { "id": "Nueva Ecija", "label": "Nueva Ecija", "value": "PH-NUE" },
            {
                "id": "Nueva Vizcaya",
                "label": "Nueva Vizcaya",
                "value": "PH-NUV"
            },
            {
                "id": "Occidental Mindoro",
                "label": "Occidental Mindoro",
                "value": "PH-MDC"
            },
            {
                "id": "Oriental Mindoro",
                "label": "Oriental Mindoro",
                "value": "PH-MDR"
            },
            { "id": "Palawan", "label": "Palawan", "value": "PH-PLW" },
            { "id": "Pampanga", "label": "Pampanga", "value": "PH-PAM" },
            { "id": "Pangasinan", "label": "Pangasinan", "value": "PH-PAN" },
            { "id": "Quezon", "label": "Quezon", "value": "PH-QUE" },
            { "id": "Quirino", "label": "Quirino", "value": "PH-QUI" },
            { "id": "Rizal", "label": "Rizal", "value": "PH-RIZ" },
            { "id": "Romblon", "label": "Romblon", "value": "PH-ROM" },
            { "id": "Samar", "label": "Samar", "value": "PH-WSA" },
            { "id": "Sarangani", "label": "Sarangani", "value": "PH-SAR" },
            { "id": "Siquijor", "label": "Siquijor", "value": "PH-SIG" },
            { "id": "Sorsogon", "label": "Sorsogon", "value": "PH-SOR" },
            {
                "id": "South Cotabato",
                "label": "South Cotabato",
                "value": "PH-SCO"
            },
            {
                "id": "Southern Leyte",
                "label": "Southern Leyte",
                "value": "PH-SLE"
            },
            {
                "id": "Sultan Kudarat",
                "label": "Sultan Kudarat",
                "value": "PH-SUK"
            },
            { "id": "Sulu", "label": "Sulu", "value": "PH-SLU" },
            {
                "id": "Surigao del Norte",
                "label": "Surigao del Norte",
                "value": "PH-SUN"
            },
            {
                "id": "Surigao del Sur",
                "label": "Surigao del Sur",
                "value": "PH-SUR"
            },
            { "id": "Tarlac", "label": "Tarlac", "value": "PH-TAR" },
            { "id": "Tawi-Tawi", "label": "Tawi-Tawi", "value": "PH-TAW" },
            { "id": "Zambales", "label": "Zambales", "value": "PH-ZMB" },
            {
                "id": "Zamboanga Sibugay",
                "label": "Zamboanga Sibugay",
                "value": "PH-ZSI"
            },
            {
                "id": "Zamboanga del Norte",
                "label": "Zamboanga del Norte",
                "value": "PH-ZAN"
            },
            {
                "id": "Zamboanga del Sur",
                "label": "Zamboanga del Sur",
                "value": "PH-ZAS"
            }
        ],
        "labels": { "province": "Region" }
    },
    "PN": {},
    "PL": {},
    "PT": {
        "provinces": [
            { "id": "Aveiro", "label": "Aveiro", "value": "PT-01" },
            {
                "id": "Açores",
                "label": "Azores",
                "alternate_names": ["Acores"],
                "value": "PT-20"
            },
            { "id": "Beja", "label": "Beja", "value": "PT-02" },
            { "id": "Braga", "label": "Braga", "value": "PT-03" },
            {
                "id": "Bragança",
                "alternate_names": ["Braganca"],
                "label": "Bragança",
                "value": "PT-04"
            },
            {
                "id": "Castelo Branco",
                "label": "Castelo Branco",
                "value": "PT-05"
            },
            { "id": "Coimbra", "label": "Coimbra", "value": "PT-06" },
            {
                "id": "Évora",
                "alternate_names": ["Evora"],
                "label": "Évora",
                "value": "PT-07"
            },
            { "id": "Faro", "label": "Faro", "value": "PT-08" },
            { "id": "Guarda", "label": "Guarda", "value": "PT-09" },
            { "id": "Leiria", "label": "Leiria", "value": "PT-10" },
            { "id": "Lisboa", "label": "Lisbon", "value": "PT-11" },
            { "id": "Madeira", "label": "Madeira", "value": "PT-30" },
            { "id": "Portalegre", "label": "Portalegre", "value": "PT-12" },
            { "id": "Porto", "label": "Porto", "value": "PT-13" },
            {
                "id": "Santarém",
                "alternate_names": ["Santarem"],
                "label": "Santarém",
                "value": "PT-14"
            },
            {
                "id": "Setúbal",
                "alternate_names": ["Setubal"],
                "label": "Setúbal",
                "value": "PT-15"
            },
            {
                "id": "Viana do Castelo",
                "label": "Viana do Castelo",
                "value": "PT-16"
            },
            { "id": "Vila Real", "label": "Vila Real", "value": "PT-17" },
            { "id": "Viseu", "label": "Viseu", "value": "PT-18" }
        ],
        "labels": { "province": "Region" }
    },
    "QA": {},
    "CM": {},
    "RE": {},
    "RO": {
        "provinces": [
            { "id": "Alba", "label": "Alba", "value": "AB" },
            { "id": "Arad", "label": "Arad", "value": "AR" },
            {
                "id": "Argeș",
                "alternate_names": ["Arge?"],
                "label": "Argeș",
                "value": "AG"
            },
            {
                "id": "Bacău",
                "alternate_names": ["Bacau"],
                "label": "Bacău",
                "value": "BC"
            },
            { "id": "Bihor", "label": "Bihor", "value": "BH" },
            {
                "id": "Bistrița-Năsăud",
                "label": "Bistriţa-Năsăud",
                "alternate_names": ["Bistri?a-Nasaud"],
                "value": "BN"
            },
            {
                "id": "Botoșani",
                "label": "Botoşani",
                "alternate_names": ["Boto?ani"],
                "value": "BT"
            },
            {
                "id": "Brăila",
                "alternate_names": ["Braila"],
                "label": "Brăila",
                "value": "BR"
            },
            {
                "id": "Brașov",
                "label": "Braşov",
                "alternate_names": ["Bra?ov"],
                "value": "BV"
            },
            {
                "id": "București",
                "label": "Bucharest",
                "alternate_names": ["Bucure?ti"],
                "value": "B"
            },
            {
                "id": "Buzău",
                "alternate_names": ["Buzau"],
                "label": "Buzău",
                "value": "BZ"
            },
            {
                "id": "Caraș-Severin",
                "alternate_names": ["Cara?-Severin"],
                "label": "Caraș-Severin",
                "value": "CS"
            },
            { "id": "Cluj", "label": "Cluj", "value": "CJ" },
            {
                "id": "Constanța",
                "alternate_names": ["Constan?a"],
                "label": "Constanța",
                "value": "CT"
            },
            { "id": "Covasna", "label": "Covasna", "value": "CV" },
            {
                "id": "Călărași",
                "alternate_names": ["Calara?i"],
                "label": "Călărași",
                "value": "CL"
            },
            { "id": "Dolj", "label": "Dolj", "value": "DJ" },
            {
                "id": "Dâmbovița",
                "alternate_names": ["Dambovi?a"],
                "label": "Dâmbovița",
                "value": "DB"
            },
            {
                "id": "Galați",
                "alternate_names": ["Gala?i"],
                "label": "Galați",
                "value": "GL"
            },
            { "id": "Giurgiu", "label": "Giurgiu", "value": "GR" },
            { "id": "Gorj", "label": "Gorj", "value": "GJ" },
            { "id": "Harghita", "label": "Harghita", "value": "HR" },
            { "id": "Hunedoara", "label": "Hunedoara", "value": "HD" },
            {
                "id": "Ialomița",
                "alternate_names": ["Ialomi?a"],
                "label": "Ialomița",
                "value": "IL"
            },
            {
                "id": "Iași",
                "alternate_names": ["Ia?i"],
                "label": "Iași",
                "value": "IS"
            },
            { "id": "Ilfov", "label": "Ilfov", "value": "IF" },
            {
                "id": "Maramureș",
                "label": "Maramureş",
                "alternate_names": ["Maramure?"],
                "value": "MM"
            },
            {
                "id": "Mehedinți",
                "alternate_names": ["Mehedin?i"],
                "label": "Mehedinți",
                "value": "MH"
            },
            {
                "id": "Mureș",
                "label": "Mureş",
                "alternate_names": ["Mure?"],
                "value": "MS"
            },
            {
                "id": "Neamț",
                "label": "Neamţ",
                "alternate_names": ["Neam?"],
                "value": "NT"
            },
            { "id": "Olt", "label": "Olt", "value": "OT" },
            { "id": "Prahova", "label": "Prahova", "value": "PH" },
            {
                "id": "Sălaj",
                "alternate_names": ["Salaj"],
                "label": "Sălaj",
                "value": "SJ"
            },
            { "id": "Satu Mare", "label": "Satu Mare", "value": "SM" },
            { "id": "Sibiu", "label": "Sibiu", "value": "SB" },
            { "id": "Suceava", "label": "Suceava", "value": "SV" },
            { "id": "Teleorman", "label": "Teleorman", "value": "TR" },
            {
                "id": "Timiș",
                "alternate_names": ["Timi?"],
                "label": "Timiș",
                "value": "TM"
            },
            { "id": "Tulcea", "label": "Tulcea", "value": "TL" },
            {
                "id": "Vâlcea",
                "alternate_names": ["Valcea"],
                "label": "Vâlcea",
                "value": "VL"
            },
            { "id": "Vaslui", "label": "Vaslui", "value": "VS" },
            { "id": "Vrancea", "label": "Vrancea", "value": "VN" }
        ],
        "labels": { "province": "County" }
    },
    "RU": {
        "provinces": [
            { "id": "Republic of Adygeya", "label": "Adygea", "value": "AD" },
            { "id": "Altai Republic", "label": "Altai", "value": "AL" },
            { "id": "Altai Krai", "label": "Altai Krai", "value": "ALT" },
            { "id": "Amur Oblast", "label": "Amur", "value": "AMU" },
            {
                "id": "Arkhangelsk Oblast",
                "label": "Arkhangelsk",
                "value": "ARK"
            },
            { "id": "Astrakhan Oblast", "label": "Astrakhan", "value": "AST" },
            {
                "id": "Republic of Bashkortostan",
                "label": "Bashkortostan",
                "value": "BA"
            },
            { "id": "Belgorod Oblast", "label": "Belgorod", "value": "BEL" },
            { "id": "Bryansk Oblast", "label": "Bryansk", "value": "BRY" },
            { "id": "Republic of Buryatia", "label": "Buryat", "value": "BU" },
            { "id": "Chechen Republic", "label": "Chechen", "value": "CE" },
            {
                "id": "Chelyabinsk Oblast",
                "label": "Chelyabinsk",
                "value": "CHE"
            },
            {
                "id": "Chukotka Autonomous Okrug",
                "label": "Chukotka Okrug",
                "value": "CHU"
            },
            { "id": "Chuvash Republic", "label": "Chuvash", "value": "CU" },
            {
                "id": "Republic of Dagestan",
                "label": "Dagestan",
                "value": "DA"
            },
            {
                "id": "Republic of Ingushetia",
                "label": "Ingushetia",
                "value": "IN"
            },
            { "id": "Irkutsk Oblast", "label": "Irkutsk", "value": "IRK" },
            { "id": "Ivanovo Oblast", "label": "Ivanovo", "value": "IVA" },
            {
                "id": "Jewish Autonomous Oblast",
                "label": "Jewish",
                "value": "YEV"
            },
            {
                "id": "Kabardino-Balkarian Republic",
                "label": "Kabardino-Balkar",
                "value": "KB"
            },
            {
                "id": "Kaliningrad Oblast",
                "label": "Kaliningrad",
                "value": "KGD"
            },
            {
                "id": "Republic of Kalmykia",
                "label": "Kalmykia",
                "value": "KL"
            },
            { "id": "Kaluga Oblast", "label": "Kaluga", "value": "KLU" },
            {
                "id": "Kamchatka Krai",
                "label": "Kamchatka Krai",
                "value": "KAM"
            },
            {
                "id": "Karachay–Cherkess Republic",
                "label": "Karachay-Cherkess",
                "alternate_names": ["Karachay?Cherkess Republic"],
                "value": "KC"
            },
            { "id": "Republic of Karelia", "label": "Karelia", "value": "KR" },
            { "id": "Kemerovo Oblast", "label": "Kemerovo", "value": "KEM" },
            {
                "id": "Khabarovsk Krai",
                "label": "Khabarovsk Krai",
                "value": "KHA"
            },
            {
                "id": "Republic of Khakassia",
                "label": "Khakassia",
                "value": "KK"
            },
            {
                "id": "Khanty-Mansi Autonomous Okrug",
                "label": "Khanty-Mansi",
                "value": "KHM"
            },
            { "id": "Kirov Oblast", "label": "Kirov", "value": "KIR" },
            { "id": "Komi Republic", "label": "Komi", "value": "KO" },
            { "id": "Kostroma Oblast", "label": "Kostroma", "value": "KOS" },
            {
                "id": "Krasnodar Krai",
                "label": "Krasnodar Krai",
                "value": "KDA"
            },
            {
                "id": "Krasnoyarsk Krai",
                "label": "Krasnoyarsk Krai",
                "value": "KYA"
            },
            { "id": "Kurgan Oblast", "label": "Kurgan", "value": "KGN" },
            { "id": "Kursk Oblast", "label": "Kursk", "value": "KRS" },
            { "id": "Leningrad Oblast", "label": "Leningrad", "value": "LEN" },
            { "id": "Lipetsk Oblast", "label": "Lipetsk", "value": "LIP" },
            { "id": "Magadan Oblast", "label": "Magadan", "value": "MAG" },
            { "id": "Mari El Republic", "label": "Mari El", "value": "ME" },
            {
                "id": "Republic of Mordovia",
                "label": "Mordovia",
                "value": "MO"
            },
            { "id": "Moscow", "label": "Moscow", "value": "MOW" },
            {
                "id": "Moscow Oblast",
                "label": "Moscow Province",
                "value": "MOS"
            },
            { "id": "Murmansk Oblast", "label": "Murmansk", "value": "MUR" },
            {
                "id": "Nizhny Novgorod Oblast",
                "label": "Nizhny Novgorod",
                "value": "NIZ"
            },
            {
                "id": "Republic of North Ossetia–Alania",
                "label": "North Ossetia-Alania",
                "alternate_names": ["Republic of North Ossetia?Alania"],
                "value": "SE"
            },
            { "id": "Novgorod Oblast", "label": "Novgorod", "value": "NGR" },
            {
                "id": "Novosibirsk Oblast",
                "label": "Novosibirsk",
                "value": "NVS"
            },
            { "id": "Omsk Oblast", "label": "Omsk", "value": "OMS" },
            { "id": "Orenburg Oblast", "label": "Orenburg", "value": "ORE" },
            { "id": "Oryol Oblast", "label": "Oryol", "value": "ORL" },
            { "id": "Penza Oblast", "label": "Penza", "value": "PNZ" },
            { "id": "Perm Krai", "label": "Perm Krai", "value": "PER" },
            {
                "id": "Primorsky Krai",
                "label": "Primorsky Krai",
                "value": "PRI"
            },
            { "id": "Pskov Oblast", "label": "Pskov", "value": "PSK" },
            { "id": "Rostov Oblast", "label": "Rostov", "value": "ROS" },
            { "id": "Ryazan Oblast", "label": "Ryazan", "value": "RYA" },
            {
                "id": "Saint Petersburg",
                "label": "Saint Petersburg",
                "value": "SPE"
            },
            {
                "id": "Sakha Republic (Yakutia)",
                "label": "Sakha",
                "value": "SA"
            },
            { "id": "Sakhalin Oblast", "label": "Sakhalin", "value": "SAK" },
            { "id": "Samara Oblast", "label": "Samara", "value": "SAM" },
            { "id": "Saratov Oblast", "label": "Saratov", "value": "SAR" },
            { "id": "Smolensk Oblast", "label": "Smolensk", "value": "SMO" },
            {
                "id": "Stavropol Krai",
                "label": "Stavropol Krai",
                "value": "STA"
            },
            {
                "id": "Sverdlovsk Oblast",
                "label": "Sverdlovsk",
                "value": "SVE"
            },
            { "id": "Tambov Oblast", "label": "Tambov", "value": "TAM" },
            {
                "id": "Republic of Tatarstan",
                "label": "Tatarstan",
                "value": "TA"
            },
            { "id": "Tomsk Oblast", "label": "Tomsk", "value": "TOM" },
            { "id": "Tula Oblast", "label": "Tula", "value": "TUL" },
            { "id": "Tyva Republic", "label": "Tuva", "value": "TY" },
            { "id": "Tver Oblast", "label": "Tver", "value": "TVE" },
            { "id": "Tyumen Oblast", "label": "Tyumen", "value": "TYU" },
            { "id": "Udmurtia", "label": "Udmurt", "value": "UD" },
            { "id": "Ulyanovsk Oblast", "label": "Ulyanovsk", "value": "ULY" },
            { "id": "Vladimir Oblast", "label": "Vladimir", "value": "VLA" },
            { "id": "Volgograd Oblast", "label": "Volgograd", "value": "VGG" },
            { "id": "Vologda Oblast", "label": "Vologda", "value": "VLG" },
            { "id": "Voronezh Oblast", "label": "Voronezh", "value": "VOR" },
            {
                "id": "Yamalo-Nenets Autonomous Okrug",
                "label": "Yamalo-Nenets Okrug",
                "value": "YAN"
            },
            { "id": "Yaroslavl Oblast", "label": "Yaroslavl", "value": "YAR" },
            {
                "id": "Zabaykalsky Krai",
                "label": "Zabaykalsky Krai",
                "value": "ZAB"
            }
        ],
        "labels": { "province": "Region" }
    },
    "RW": {},
    "BL": {},
    "SH": {},
    "KN": { "labels": { "zip": "Postal code (optional)" } },
    "LC": { "labels": { "zip": "Postal code (optional)" } },
    "MF": {},
    "PM": {},
    "WS": { "labels": { "zip": "Postal code (optional)" } },
    "SM": {},
    "ST": {},
    "SA": { "labels": { "zip": "Postal code (optional)" } },
    "SN": { "labels": { "zip": "Postal code (optional)" } },
    "RS": {},
    "SC": {},
    "SL": {},
    "SG": {},
    "SX": {},
    "SK": {},
    "SI": {},
    "SB": {},
    "SO": { "labels": { "zip": "Postal code (optional)" } },
    "ZA": {
        "provinces": [
            { "id": "Eastern Cape", "label": "Eastern Cape", "value": "EC" },
            { "id": "Free State", "label": "Free State", "value": "FS" },
            { "id": "Gauteng", "label": "Gauteng", "value": "GP" },
            { "id": "KwaZulu-Natal", "label": "KwaZulu-Natal", "value": "NL" },
            { "id": "Limpopo", "label": "Limpopo", "value": "LP" },
            { "id": "Mpumalanga", "label": "Mpumalanga", "value": "MP" },
            { "id": "North West", "label": "North West", "value": "NW" },
            { "id": "Northern Cape", "label": "Northern Cape", "value": "NC" },
            { "id": "Western Cape", "label": "Western Cape", "value": "WC" }
        ],
        "labels": { "address2": "Suburb (optional)", "province": "Province" }
    },
    "GS": {},
    "KR": {
        "provinces": [
            { "id": "Busan", "label": "Busan", "value": "KR-26" },
            { "id": "Daegu", "label": "Daegu", "value": "KR-27" },
            { "id": "Daejeon", "label": "Daejeon", "value": "KR-30" },
            { "id": "Gangwon", "label": "Gangwon", "value": "KR-42" },
            { "id": "Gwangju", "label": "Gwangju City", "value": "KR-29" },
            { "id": "Gyeonggi", "label": "Gyeonggi", "value": "KR-41" },
            { "id": "Incheon", "label": "Incheon", "value": "KR-28" },
            { "id": "Jeju", "label": "Jeju", "value": "KR-49" },
            {
                "id": "Chungbuk",
                "label": "North Chungcheong",
                "value": "KR-43"
            },
            {
                "id": "Gyeongbuk",
                "label": "North Gyeongsang",
                "value": "KR-47"
            },
            { "id": "Jeonbuk", "label": "North Jeolla", "value": "KR-45" },
            { "id": "Sejong", "label": "Sejong", "value": "KR-50" },
            { "id": "Seoul", "label": "Seoul", "value": "KR-11" },
            {
                "id": "Chungnam",
                "label": "South Chungcheong",
                "value": "KR-44"
            },
            {
                "id": "Gyeongnam",
                "label": "South Gyeongsang",
                "value": "KR-48"
            },
            { "id": "Jeonnam", "label": "South Jeolla", "value": "KR-46" },
            { "id": "Ulsan", "label": "Ulsan", "value": "KR-31" }
        ],
        "labels": { "province": "Province" }
    },
    "SS": {},
    "ES": {
        "provinces": [
            {
                "id": "A Coruña",
                "alternate_names": ["A Coruna"],
                "label": "A Coruña",
                "value": "C"
            },
            {
                "id": "Álava",
                "alternate_names": ["Alava", "Araba"],
                "label": "Álava",
                "value": "VI"
            },
            { "id": "Albacete", "label": "Albacete", "value": "AB" },
            { "id": "Alicante", "label": "Alicante", "value": "A" },
            {
                "id": "Almería",
                "alternate_names": ["Almeria"],
                "label": "Almería",
                "value": "AL"
            },
            {
                "id": "Asturias",
                "label": "Asturias Province",
                "alternate_names": ["Principado de Asturias"],
                "value": "O"
            },
            {
                "id": "Ávila",
                "alternate_names": ["Avila"],
                "label": "Ávila",
                "value": "AV"
            },
            { "id": "Badajoz", "label": "Badajoz", "value": "BA" },
            {
                "id": "Balears",
                "label": "Balears Province",
                "alternate_names": [
                    "Baleares",
                    "Illes Balears",
                    "Islas Baleares"
                ],
                "value": "PM"
            },
            { "id": "Barcelona", "label": "Barcelona", "value": "B" },
            {
                "id": "Vizcaya",
                "label": "Biscay",
                "alternate_names": ["Biscay", "Bizkaia"],
                "value": "BI"
            },
            { "id": "Burgos", "label": "Burgos", "value": "BU" },
            {
                "id": "Cáceres",
                "alternate_names": ["Caceres"],
                "label": "Cáceres",
                "value": "CC"
            },
            {
                "id": "Cádiz",
                "alternate_names": ["Cadiz"],
                "label": "Cádiz",
                "value": "CA"
            },
            { "id": "Cantabria", "label": "Cantabria Province", "value": "S" },
            {
                "id": "Castellón",
                "alternate_names": ["Castellon", "Castelló", "Castello"],
                "label": "Castellón",
                "value": "CS"
            },
            { "id": "Ceuta", "label": "Ceuta", "value": "CE" },
            {
                "id": "Ciudad Real",
                "alternate_names": ["Cdad. Real"],
                "label": "Ciudad Real",
                "value": "CR"
            },
            {
                "id": "Córdoba",
                "alternate_names": ["Cordoba", "Cordova"],
                "label": "Córdoba",
                "value": "CO"
            },
            { "id": "Cuenca", "label": "Cuenca", "value": "CU" },
            {
                "id": "Guipúzcoa",
                "label": "Gipuzkoa",
                "alternate_names": ["Guipuzcoa", "Gipuzkoa"],
                "value": "SS"
            },
            {
                "id": "Girona",
                "alternate_names": ["Gerona"],
                "label": "Girona",
                "value": "GI"
            },
            { "id": "Granada", "label": "Granada", "value": "GR" },
            { "id": "Guadalajara", "label": "Guadalajara", "value": "GU" },
            { "id": "Huelva", "label": "Huelva", "value": "H" },
            {
                "id": "Huesca",
                "alternate_names": ["Uesca", "Osca"],
                "label": "Huesca",
                "value": "HU"
            },
            {
                "id": "Jaén",
                "alternate_names": ["Jaen"],
                "label": "Jaén",
                "value": "J"
            },
            { "id": "La Rioja", "label": "La Rioja Province", "value": "LO" },
            { "id": "Las Palmas", "label": "Las Palmas", "value": "GC" },
            {
                "id": "León",
                "alternate_names": ["Leon"],
                "label": "León",
                "value": "LE"
            },
            {
                "id": "Lleida",
                "alternate_names": ["Lérida", "Lerida"],
                "label": "Lleida",
                "value": "L"
            },
            { "id": "Lugo", "label": "Lugo", "value": "LU" },
            {
                "id": "Madrid",
                "label": "Madrid Province",
                "alternate_names": [
                    "Comunidad de Madrid",
                    "Community of Madrid"
                ],
                "value": "M"
            },
            {
                "id": "Málaga",
                "alternate_names": ["Malaga"],
                "label": "Málaga",
                "value": "MA"
            },
            { "id": "Melilla", "label": "Melilla", "value": "ML" },
            {
                "id": "Murcia",
                "alternate_names": ["Región de Murcia", "Region de Murcia"],
                "label": "Murcia",
                "value": "MU"
            },
            {
                "id": "Navarra",
                "alternate_names": ["Nafarroa", "Navarre"],
                "label": "Navarra",
                "value": "NA"
            },
            { "id": "Ourense", "label": "Ourense", "value": "OR" },
            { "id": "Palencia", "label": "Palencia", "value": "P" },
            { "id": "Pontevedra", "label": "Pontevedra", "value": "PO" },
            { "id": "Salamanca", "label": "Salamanca", "value": "SA" },
            {
                "id": "Santa Cruz de Tenerife",
                "alternate_names": ["Santa Cruz"],
                "label": "Santa Cruz de Tenerife",
                "value": "TF"
            },
            { "id": "Segovia", "label": "Segovia", "value": "SG" },
            {
                "id": "Sevilla",
                "label": "Seville",
                "alternate_names": ["Seville"],
                "value": "SE"
            },
            { "id": "Soria", "label": "Soria", "value": "SO" },
            { "id": "Tarragona", "label": "Tarragona", "value": "T" },
            { "id": "Teruel", "label": "Teruel", "value": "TE" },
            { "id": "Toledo", "label": "Toledo", "value": "TO" },
            {
                "id": "Valencia",
                "alternate_names": ["València"],
                "label": "Valencia",
                "value": "V"
            },
            { "id": "Valladolid", "label": "Valladolid", "value": "VA" },
            { "id": "Zamora", "label": "Zamora", "value": "ZA" },
            {
                "id": "Zaragoza",
                "alternate_names": ["Saragossa"],
                "label": "Zaragoza",
                "value": "Z"
            }
        ],
        "labels": {
            "address1": "Street and house number",
            "province": "Province"
        }
    },
    "LK": {},
    "VC": { "labels": { "zip": "Postal code (optional)" } },
    "SD": { "labels": { "zip": "Postal code (optional)" } },
    "SR": {},
    "SJ": {},
    "SE": {
        "labels": { "address1": "Street and house number", "city": "City/town" }
    },
    "CH": {
        "labels": {
            "address1": "Street and house number",
            "address2": "Additional address (optional)"
        }
    },
    "SY": { "labels": { "zip": "Postal code (optional)" } },
    "TW": {},
    "TJ": {},
    "TZ": { "labels": { "zip": "Postal code (optional)" } },
    "TH": {
        "provinces": [
            {
                "id": "Amnat Charoen",
                "label": "Amnat Charoen",
                "value": "TH-37"
            },
            { "id": "Ang Thong", "label": "Ang Thong", "value": "TH-15" },
            {
                "id": "Bangkok",
                "alternate_names": ["Krung Thep Maha Nakhon"],
                "label": "Bangkok",
                "value": "TH-10"
            },
            { "id": "Bueng Kan", "label": "Bueng Kan", "value": "TH-38" },
            {
                "id": "Buriram",
                "label": "Buri Ram",
                "alternate_names": ["Buri Ram"],
                "value": "TH-31"
            },
            { "id": "Chachoengsao", "label": "Chachoengsao", "value": "TH-24" },
            { "id": "Chai Nat", "label": "Chai Nat", "value": "TH-18" },
            { "id": "Chaiyaphum", "label": "Chaiyaphum", "value": "TH-36" },
            { "id": "Chanthaburi", "label": "Chanthaburi", "value": "TH-22" },
            { "id": "Chiang Mai", "label": "Chiang Mai", "value": "TH-50" },
            { "id": "Chiang Rai", "label": "Chiang Rai", "value": "TH-57" },
            { "id": "Chon Buri", "label": "Chon Buri", "value": "TH-20" },
            { "id": "Chumphon", "label": "Chumphon", "value": "TH-86" },
            { "id": "Kalasin", "label": "Kalasin", "value": "TH-46" },
            {
                "id": "Kamphaeng Phet",
                "label": "Kamphaeng Phet",
                "value": "TH-62"
            },
            { "id": "Kanchanaburi", "label": "Kanchanaburi", "value": "TH-71" },
            { "id": "Khon Kaen", "label": "Khon Kaen", "value": "TH-40" },
            { "id": "Krabi", "label": "Krabi", "value": "TH-81" },
            { "id": "Lampang", "label": "Lampang", "value": "TH-52" },
            { "id": "Lamphun", "label": "Lamphun", "value": "TH-51" },
            { "id": "Loei", "label": "Loei", "value": "TH-42" },
            {
                "id": "Lopburi",
                "alternate_names": ["Lop Buri"],
                "label": "Lopburi",
                "value": "TH-16"
            },
            { "id": "Mae Hong Son", "label": "Mae Hong Son", "value": "TH-58" },
            {
                "id": "Maha Sarakham",
                "label": "Maha Sarakham",
                "value": "TH-44"
            },
            { "id": "Mukdahan", "label": "Mukdahan", "value": "TH-49" },
            { "id": "Nakhon Nayok", "label": "Nakhon Nayok", "value": "TH-26" },
            {
                "id": "Nakhon Pathom",
                "label": "Nakhon Pathom",
                "value": "TH-73"
            },
            {
                "id": "Nakhon Phanom",
                "label": "Nakhon Phanom",
                "value": "TH-48"
            },
            {
                "id": "Nakhon Ratchasima",
                "label": "Nakhon Ratchasima",
                "value": "TH-30"
            },
            { "id": "Nakhon Sawan", "label": "Nakhon Sawan", "value": "TH-60" },
            {
                "id": "Nakhon Si Thammarat",
                "label": "Nakhon Si Thammarat",
                "value": "TH-80"
            },
            { "id": "Nan", "label": "Nan", "value": "TH-55" },
            { "id": "Narathiwat", "label": "Narathiwat", "value": "TH-96" },
            {
                "id": "Nong Bua Lam Phu",
                "label": "Nong Bua Lam Phu",
                "value": "TH-39"
            },
            { "id": "Nong Khai", "label": "Nong Khai", "value": "TH-43" },
            { "id": "Nonthaburi", "label": "Nonthaburi", "value": "TH-12" },
            { "id": "Pathum Thani", "label": "Pathum Thani", "value": "TH-13" },
            { "id": "Pattani", "label": "Pattani", "value": "TH-94" },
            { "id": "Pattaya", "label": "Pattaya", "value": "TH-S" },
            { "id": "Phangnga", "label": "Phang Nga", "value": "TH-82" },
            { "id": "Phatthalung", "label": "Phatthalung", "value": "TH-93" },
            { "id": "Phayao", "label": "Phayao", "value": "TH-56" },
            { "id": "Phetchabun", "label": "Phetchabun", "value": "TH-67" },
            { "id": "Phetchaburi", "label": "Phetchaburi", "value": "TH-76" },
            { "id": "Phichit", "label": "Phichit", "value": "TH-66" },
            { "id": "Phitsanulok", "label": "Phitsanulok", "value": "TH-65" },
            {
                "id": "Phra Nakhon Si Ayutthaya",
                "label": "Phra Nakhon Si Ayutthaya",
                "value": "TH-14"
            },
            { "id": "Phrae", "label": "Phrae", "value": "TH-54" },
            { "id": "Phuket", "label": "Phuket", "value": "TH-83" },
            { "id": "Prachin Buri", "label": "Prachin Buri", "value": "TH-25" },
            {
                "id": "Prachuap Khiri Khan",
                "label": "Prachuap Khiri Khan",
                "value": "TH-77"
            },
            { "id": "Ranong", "label": "Ranong", "value": "TH-85" },
            { "id": "Ratchaburi", "label": "Ratchaburi", "value": "TH-70" },
            { "id": "Rayong", "label": "Rayong", "value": "TH-21" },
            { "id": "Roi Et", "label": "Roi Et", "value": "TH-45" },
            { "id": "Sa Kaeo", "label": "Sa Kaeo", "value": "TH-27" },
            { "id": "Sakon Nakhon", "label": "Sakon Nakhon", "value": "TH-47" },
            { "id": "Samut Prakan", "label": "Samut Prakan", "value": "TH-11" },
            { "id": "Samut Sakhon", "label": "Samut Sakhon", "value": "TH-74" },
            {
                "id": "Samut Songkhram",
                "label": "Samut Songkhram",
                "value": "TH-75"
            },
            { "id": "Saraburi", "label": "Saraburi", "value": "TH-19" },
            { "id": "Satun", "label": "Satun", "value": "TH-91" },
            {
                "id": "Sisaket",
                "label": "Si Sa Ket",
                "alternate_names": ["Si Sa Ket"],
                "value": "TH-33"
            },
            { "id": "Sing Buri", "label": "Sing Buri", "value": "TH-17" },
            { "id": "Songkhla", "label": "Songkhla", "value": "TH-90" },
            { "id": "Sukhothai", "label": "Sukhothai", "value": "TH-64" },
            { "id": "Suphan Buri", "label": "Suphanburi", "value": "TH-72" },
            { "id": "Surat Thani", "label": "Surat Thani", "value": "TH-84" },
            { "id": "Surin", "label": "Surin", "value": "TH-32" },
            { "id": "Tak", "label": "Tak", "value": "TH-63" },
            { "id": "Trang", "label": "Trang", "value": "TH-92" },
            { "id": "Trat", "label": "Trat", "value": "TH-23" },
            {
                "id": "Ubon Ratchathani",
                "label": "Ubon Ratchathani",
                "value": "TH-34"
            },
            { "id": "Udon Thani", "label": "Udon Thani", "value": "TH-41" },
            { "id": "Uthai Thani", "label": "Uthai Thani", "value": "TH-61" },
            { "id": "Uttaradit", "label": "Uttaradit", "value": "TH-53" },
            { "id": "Yala", "label": "Yala", "value": "TH-95" },
            { "id": "Yasothon", "label": "Yasothon", "value": "TH-35" }
        ],
        "labels": { "province": "Province" }
    },
    "TL": {},
    "TG": {},
    "TK": {},
    "TO": {},
    "TT": { "labels": { "zip": "Postal code (optional)" } },
    "TA": {},
    "TN": {},
    "TR": {},
    "TM": {},
    "TC": {},
    "TV": {},
    "UG": {},
    "UA": {},
    "AE": {
        "provinces": [
            { "id": "Abu Dhabi", "label": "Abu Dhabi", "value": "AZ" },
            { "id": "Ajman", "label": "Ajman", "value": "AJ" },
            { "id": "Dubai", "label": "Dubai", "value": "DU" },
            { "id": "Fujairah", "label": "Fujairah", "value": "FU" },
            {
                "id": "Ras al-Khaimah",
                "label": "Ras al-Khaimah",
                "value": "RK"
            },
            { "id": "Sharjah", "label": "Sharjah", "value": "SH" },
            { "id": "Umm al-Quwain", "label": "Umm al-Quwain", "value": "UQ" }
        ],
        "labels": { "province": "Emirate" }
    },
    "GB": {
        "provinces": [
            {
                "id": "British Forces",
                "label": "British Forces",
                "value": "BFP"
            },
            { "id": "England", "label": "England", "value": "ENG" },
            {
                "id": "Northern Ireland",
                "label": "Northern Ireland",
                "value": "NIR"
            },
            { "id": "Scotland", "label": "Scotland", "value": "SCT" },
            { "id": "Wales", "label": "Wales", "value": "WLS" }
        ],
        "labels": { "zip": "Postcode", "province": "Region" }
    },
    "US": {
        "provinces": [
            { "id": "Alabama", "label": "Alabama", "value": "AL" },
            { "id": "Alaska", "label": "Alaska", "value": "AK" },
            {
                "id": "American Samoa",
                "label": "American Samoa",
                "value": "AS"
            },
            { "id": "Arizona", "label": "Arizona", "value": "AZ" },
            { "id": "Arkansas", "label": "Arkansas", "value": "AR" },
            { "id": "California", "label": "California", "value": "CA" },
            { "id": "Colorado", "label": "Colorado", "value": "CO" },
            { "id": "Connecticut", "label": "Connecticut", "value": "CT" },
            { "id": "Delaware", "label": "Delaware", "value": "DE" },
            { "id": "Florida", "label": "Florida", "value": "FL" },
            { "id": "Georgia", "label": "Georgia", "value": "GA" },
            { "id": "Guam", "label": "Guam", "value": "GU" },
            { "id": "Hawaii", "label": "Hawaii", "value": "HI" },
            { "id": "Idaho", "label": "Idaho", "value": "ID" },
            { "id": "Illinois", "label": "Illinois", "value": "IL" },
            { "id": "Indiana", "label": "Indiana", "value": "IN" },
            { "id": "Iowa", "label": "Iowa", "value": "IA" },
            { "id": "Kansas", "label": "Kansas", "value": "KS" },
            { "id": "Kentucky", "label": "Kentucky", "value": "KY" },
            { "id": "Louisiana", "label": "Louisiana", "value": "LA" },
            { "id": "Maine", "label": "Maine", "value": "ME" },
            {
                "id": "Marshall Islands",
                "label": "Marshall Islands",
                "value": "MH"
            },
            { "id": "Maryland", "label": "Maryland", "value": "MD" },
            { "id": "Massachusetts", "label": "Massachusetts", "value": "MA" },
            { "id": "Michigan", "label": "Michigan", "value": "MI" },
            {
                "id": "Federated States of Micronesia",
                "label": "Micronesia",
                "value": "FM"
            },
            { "id": "Minnesota", "label": "Minnesota", "value": "MN" },
            { "id": "Mississippi", "label": "Mississippi", "value": "MS" },
            { "id": "Missouri", "label": "Missouri", "value": "MO" },
            { "id": "Montana", "label": "Montana", "value": "MT" },
            { "id": "Nebraska", "label": "Nebraska", "value": "NE" },
            { "id": "Nevada", "label": "Nevada", "value": "NV" },
            { "id": "New Hampshire", "label": "New Hampshire", "value": "NH" },
            { "id": "New Jersey", "label": "New Jersey", "value": "NJ" },
            { "id": "New Mexico", "label": "New Mexico", "value": "NM" },
            { "id": "New York", "label": "New York", "value": "NY" },
            {
                "id": "North Carolina",
                "label": "North Carolina",
                "value": "NC"
            },
            { "id": "North Dakota", "label": "North Dakota", "value": "ND" },
            {
                "id": "Northern Mariana Islands",
                "label": "Northern Mariana Islands",
                "value": "MP"
            },
            { "id": "Ohio", "label": "Ohio", "value": "OH" },
            { "id": "Oklahoma", "label": "Oklahoma", "value": "OK" },
            { "id": "Oregon", "label": "Oregon", "value": "OR" },
            { "id": "Palau", "label": "Palau", "value": "PW" },
            { "id": "Pennsylvania", "label": "Pennsylvania", "value": "PA" },
            { "id": "Puerto Rico", "label": "Puerto Rico", "value": "PR" },
            { "id": "Rhode Island", "label": "Rhode Island", "value": "RI" },
            {
                "id": "South Carolina",
                "label": "South Carolina",
                "value": "SC"
            },
            { "id": "South Dakota", "label": "South Dakota", "value": "SD" },
            { "id": "Tennessee", "label": "Tennessee", "value": "TN" },
            { "id": "Texas", "label": "Texas", "value": "TX" },
            {
                "id": "Virgin Islands",
                "label": "U.S. Virgin Islands",
                "value": "VI"
            },
            { "id": "Utah", "label": "Utah", "value": "UT" },
            { "id": "Vermont", "label": "Vermont", "value": "VT" },
            { "id": "Virginia", "label": "Virginia", "value": "VA" },
            { "id": "Washington", "label": "Washington", "value": "WA" },
            {
                "id": "District of Columbia",
                "label": "Washington DC",
                "value": "DC"
            },
            { "id": "West Virginia", "label": "West Virginia", "value": "WV" },
            { "id": "Wisconsin", "label": "Wisconsin", "value": "WI" },
            { "id": "Wyoming", "label": "Wyoming", "value": "WY" },
            {
                "id": "Armed Forces Americas",
                "label": "Armed Forces Americas",
                "value": "AA"
            },
            {
                "id": "Armed Forces Europe",
                "label": "Armed Forces Europe",
                "value": "AE"
            },
            {
                "id": "Armed Forces Pacific",
                "label": "Armed Forces Pacific",
                "value": "AP"
            }
        ],
        "labels": { "province": "State", "zip": "ZIP code" }
    },
    "UM": {},
    "UY": { "labels": { "zip": "Postal code (optional)" } },
    "UZ": { "labels": { "zip": "Postal code (optional)" } },
    "VU": {},
    "VE": { "labels": { "zip": "Postal code (optional)" } },
    "VN": { "labels": { "zip": "Postal code (optional)" } },
    "VG": {},
    "WF": {},
    "EH": { "labels": { "zip": "Postal code (optional)" } },
    "YE": {},
    "ZM": { "labels": { "zip": "Postal code (optional)" } },
    "ZW": {}
};
const bssB2BArrayCountry = [
    { label: "Afghanistan", value: "AF" },
    { label: "Aland Islands", value: "AX" },
    { label: "Albania", value: "AL" },
    { label: "Algeria", value: "DZ" },
    { label: "Andorra", value: "AD" },
    { label: "Angola", value: "AO" },
    { label: "Anguilla", value: "AI" },
    { label: "Antigua & Barbuda", value: "AG" },
    { label: "Argentina", value: "AR" },
    { label: "Armenia", value: "AM" },
    { label: "Aruba", value: "AW" },
    {
        label: "Ascension Island",
        value: "AC",
    },
    { label: "Australia", value: "AU" },
    { label: "Austria", value: "AT" },
    { label: "Azerbaijan", value: "AZ" },
    { label: "Bahamas", value: "BS" },
    { label: "Bahrain", value: "BH" },
    { label: "Bangladesh", value: "BD" },
    { label: "Barbados", value: "BB" },
    { label: "Belarus", value: "BY" },
    { label: "Belgium", value: "BE" },
    { label: "Belize", value: "BZ" },
    { label: "Benin", value: "BJ" },
    { label: "Bermuda", value: "BM" },
    { label: "Bhutan", value: "BT" },
    { label: "Bolivia", value: "BO" },
    { label: "Bosnia & Herzegovina", value: "BA" },
    { label: "Botswana", value: "BW" },
    { label: "Bouvet Island", value: "BV" },
    { label: "Brazil", value: "BR" },
    { label: "British Indian Ocean Territory", value: "IO" },
    { label: "British Virgin Islands", value: "VG" },
    { label: "Brunei", value: "BN" },
    { label: "Bulgaria", value: "BG" },
    { label: "Burkina Faso", value: "BF" },
    { label: "Burundi", value: "BI" },
    { label: "Cambodia", value: "KH" },
    { label: "Cameroon", value: "CM" },
    { label: "Canada", value: "CA" },
    { label: "Cape Verde", value: "CV" },
    { label: "Caribbean Netherlands", value: "BQ" },
    { label: "Cayman Islands", value: "KY" },
    { label: "Central African Republic", value: "CF" },
    { label: "Chad", value: "TD" },
    { label: "Chile", value: "CL" },
    { label: "China", value: "CN" },
    { label: "Christmas Island", value: "CX" },
    { label: "Cocos (Keeling) Islands", value: "CC" },
    { label: "Colombia", value: "CO" },
    { label: "Comoros", value: "KM" },
    { label: "Congo - Brazzaville", value: "CG" },
    { label: "Congo - Kinshasa", value: "CD" },
    { label: "Cook Islands", value: "CK" },
    { label: "Costa Rica", value: "CR" },
    { label: "Côte d'Ivoire", value: "CI" },
    { label: "Croatia", value: "HR" },
    { label: "Cuba", value: "CU" },
    { label: "Curaçao", value: "CW" },
    { label: "Cyprus", value: "CY" },
    { label: "Czechia", value: "CZ" },
    { label: "Denmark", value: "DK" },
    { label: "Djibouti", value: "DJ" },
    { label: "Dominica", value: "DM" },
    { label: "Dominican Republic", value: "DO" },
    { label: "Ecuador", value: "EC" },
    { label: "Egypt", value: "EG" },
    { label: "El Salvador", value: "SV" },
    { label: "Equatorial Guinea", value: "GQ" },
    { label: "Eritrea", value: "ER" },
    { label: "Estonia", value: "EE" },
    { label: "Eswatini", value: "SZ" },
    { label: "Ethiopia", value: "ET" },
    { label: "Falkland Islands", value: "FK" },
    { label: "Faroe Islands", value: "FO" },
    { label: "Fiji", value: "FJ" },
    { label: "Finland", value: "FI" },
    { label: "France", value: "FR" },
    { label: "French Guiana", value: "GF" },
    { label: "French Polynesia", value: "PF" },
    { label: "French Southern Territories", value: "TF" },
    { label: "Gabon", value: "GA" },
    { label: "Gambia", value: "GM" },
    { label: "Georgia", value: "GE" },
    { label: "Germany", value: "DE" },
    { label: "Ghana", value: "GH" },
    { label: "Gibraltar", value: "GI" },
    { label: "Greece", value: "GR" },
    { label: "Greenland", value: "GL" },
    { label: "Grenada", value: "GD" },
    { label: "Guadeloupe", value: "GP" },
    { label: "Guam", value: "GU" },
    { label: "Guatemala", value: "GT" },
    { label: "Guernsey", value: "GG" },
    { label: "Guinea", value: "GN" },
    { label: "Guinea-Bissau", value: "GW" },
    { label: "Guyana", value: "GY" },
    { label: "Haiti", value: "HT" },
    { label: "Heard & McDonald Islands", value: "HM" },
    { label: "Honduras", value: "HN" },
    { label: "Hong Kong SAR", value: "HK" },
    { label: "Hungary", value: "HU" },
    { label: "Iceland", value: "IS" },
    { label: "India", value: "IN" },
    { label: "Indonesia", value: "ID" },
    { label: "Iran", value: "IR" },
    { label: "Iraq", value: "IQ" },
    { label: "Ireland", value: "IE" },
    { label: "Isle of Man", value: "IM" },
    { label: "Israel", value: "IL" },
    { label: "Italy", value: "IT" },
    { label: "Jamaica", value: "JM" },
    { label: "Japan", value: "JP" },
    { label: "Jersey", value: "JE" },
    { label: "Jordan", value: "JO" },
    { label: "Kazakhstan", value: "KZ" },
    { label: "Kenya", value: "KE" },
    { label: "Kiribati", value: "KI" },
    {
        label: "Kosovo",
        value: "XK",
    },
    { label: "Kuwait", value: "KW" },
    { label: "Kyrgyzstan", value: "KG" },
    { label: "Laos", value: "LA" },
    { label: "Latvia", value: "LV" },
    { label: "Lebanon", value: "LB" },
    { label: "Lesotho", value: "LS" },
    { label: "Liberia", value: "LR" },
    { label: "Libya", value: "LY" },
    { label: "Liechtenstein", value: "LI" },
    { label: "Lithuania", value: "LT" },
    { label: "Luxembourg", value: "LU" },
    { label: "Macao SAR China", value: "MO" },
    { label: "Madagascar", value: "MG" },
    { label: "Malawi", value: "MW" },
    { label: "Malaysia", value: "MY" },
    { label: "Maldives", value: "MV" },
    { label: "Mali", value: "ML" },
    { label: "Malta", value: "MT" },
    { label: "Martinique", value: "MQ" },
    { label: "Mauritania", value: "MR" },
    { label: "Mauritius", value: "MU" },
    { label: "Mayotte", value: "YT" },
    { label: "Mexico", value: "MX" },
    { label: "Moldova", value: "MD" },
    { label: "Monaco", value: "MC" },
    { label: "Mongolia", value: "MN" },
    { label: "Montenegro", value: "ME" },
    { label: "Montserrat", value: "MS" },
    { label: "Morocco", value: "MA" },
    { label: "Mozambique", value: "MZ" },
    { label: "Myanmar (Burma)", value: "MM" },
    { label: "Namibia", value: "NA" },
    { label: "Nauru", value: "NR" },
    { label: "Nepal", value: "NP" },
    { label: "Netherlands", value: "NL" },
    {
        label: "Netherlands Antilles",
        value: "AN",
    },
    { label: "New Caledonia", value: "NC" },
    { label: "New Zealand", value: "NZ" },
    { label: "Nicaragua", value: "NI" },
    { label: "Niger", value: "NE" },
    { label: "Nigeria", value: "NG" },
    { label: "Niue", value: "NU" },
    { label: "Norfolk Island", value: "NF" },
    { label: "North Korea", value: "KP" },
    { label: "North Macedonia", value: "MK" },
    { label: "Norway", value: "NO" },
    { label: "Oman", value: "OM" },
    { label: "Pakistan", value: "PK" },
    { label: "Palestinian Territories", value: "PS" },
    { label: "Panama", value: "PA" },
    { label: "Papua New Guinea", value: "PG" },
    { label: "Paraguay", value: "PY" },
    { label: "Peru", value: "PE" },
    { label: "Philippines", value: "PH" },
    { label: "Pitcairn Islands", value: "PN" },
    { label: "Poland", value: "PL" },
    { label: "Portugal", value: "PT" },
    { label: "Qatar", value: "QA" },
    { label: "Reunion", value: "RE" },
    { label: "Romania", value: "RO" },
    { label: "Russia", value: "RU" },
    { label: "Rwanda", value: "RW" },
    { label: "Samoa", value: "WS" },
    { label: "San Marino", value: "SM" },
    { label: "Sao Tome And Principe", value: "ST" },
    { label: "Saudi Arabia", value: "SA" },
    { label: "Senegal", value: "SN" },
    { label: "Serbia", value: "RS" },
    { label: "Seychelles", value: "SC" },
    { label: "Sierra Leone", value: "SL" },
    { label: "Singapore", value: "SG" },
    { label: "Sint Maarten", value: "SX" },
    { label: "Slovakia", value: "SK" },
    { label: "Slovenia", value: "SI" },
    { label: "Solomon Islands", value: "SB" },
    { label: "Somalia", value: "SO" },
    { label: "South Africa", value: "ZA" },
    { label: "South Georgia & South Sandwich Islands", value: "GS" },
    { label: "South Korea", value: "KR" },
    { label: "South Sudan", value: "SS" },
    { label: "Spain", value: "ES" },
    { label: "Sri Lanka", value: "LK" },
    { label: "St. Barthélemy", value: "BL" },
    { label: "St. Helena", value: "SH" },
    { label: "St. Kitts & Nevis", value: "KN" },
    { label: "St. Lucia", value: "LC" },
    { label: "St. Martin", value: "MF" },
    { label: "St. Pierre & Miquelon", value: "PM" },
    { label: "St. Vincent & Grenadines", value: "VC" },
    { label: "Sudan", value: "SD" },
    { label: "Suriname", value: "SR" },
    { label: "Svalbard & Jan Mayen", value: "SJ" },
    { label: "Sweden", value: "SE" },
    { label: "Switzerland", value: "CH" },
    { label: "Syria", value: "SY" },
    { label: "Taiwan", value: "TW" },
    { label: "Tajikistan", value: "TJ" },
    { label: "Tanzania", value: "TZ" },
    { label: "Thailand", value: "TH" },
    { label: "Timor-Leste", value: "TL" },
    { label: "Togo", value: "TG" },
    { label: "Tokelau", value: "TK" },
    { label: "Tonga", value: "TO" },
    { label: "Trinidad & Tobago", value: "TT" },
    {
        label: "Tristan da Cunha",
        value: "TA",
    },
    { label: "Tunisia", value: "TN" },
    { label: "Turkey", value: "TR" },
    { label: "Turkmenistan", value: "TM" },
    { label: "Turks & Caicos Islands", value: "TC" },
    { label: "Tuvalu", value: "TV" },
    { label: "U.S. Outlying Islands", value: "UM" },
    { label: "Uganda", value: "UG" },
    { label: "Ukraine", value: "UA" },
    { label: "United Arab Emirates", value: "AE" },
    { label: "United Kingdom", value: "GB" },
    { label: "United States", value: "US" },
    { label: "Uruguay", value: "UY" },
    { label: "Uzbekistan", value: "UZ" },
    { label: "Vanuatu", value: "VU" },
    { label: "Vatican City", value: "VA" },
    { label: "Venezuela", value: "VE" },
    { label: "Vietnam", value: "VN" },
    { label: "Wallis & Futuna", value: "WF" },
    { label: "Western Sahara", value: "EH" },
    { label: "Yemen", value: "YE" },
    { label: "Zambia", value: "ZM" },
    { label: "Zimbabwe", value: "ZW" },
];
